import React from "react";

const ConfirmSellerArtwork = ({ accentColor = "#FD5154" }) => (
  <svg width="429px" height="184px" viewBox="0 0 429 184" version="1.1">
    <title>Home Value</title>
    <desc>A Home Shows a Pricing Pin Above It</desc>
    <defs>
      <rect id="path-1" x="0" y="0" width="1290" height="793"></rect>
      <rect id="path-3" x="0" y="127" width="1290" height="666"></rect>
      <filter
        x="-50%"
        y="-50%"
        width="200%"
        height="200%"
        filterUnits="objectBoundingBox"
        id="filter-4">
        <feOffset
          dx="0"
          dy="2"
          in="SourceAlpha"
          result="shadowOffsetOuter1"></feOffset>
        <feGaussianBlur
          stdDeviation="5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0"
          type="matrix"
          in="shadowBlurOuter1"></feColorMatrix>
      </filter>
    </defs>
    <g
      id="Seller-Flow"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd">
      <g id="3-Done" transform="translate(-431.000000, -483.000000)">
        <g id="photo-1425363352475-960422935a30">
          <mask id="mask-2" fill="white"></mask>
        </g>
        <g id="Home-Value" transform="translate(431.000000, 483.000000)">
          <g id="Layer_1">
            <path
              d="M196.52,18 C196.52,26.6 210.83,48.22 213.67,52.42 C216.51,48.21 230.82,26.6 230.82,18 C230.595197,8.6923595 222.985355,1.2640954 213.675,1.2640954 C204.364645,1.2640954 196.754803,8.6923595 196.53,18 L196.52,18 Z M213.64,22 C210.39,21.69 207.21,21.05 207.24,17.16 C207.24,14.25 209.78,12.83 212.5,12.61 L212.5,10.82 L215.41,10.82 L215.41,12.65 C217.42253,12.7516038 219.214762,13.9553993 220.07,15.78 L217.35,17 C216.53694,15.8291923 215.172964,15.1661484 213.75,15.25 C212.18,15.25 210.66,15.85 210.64,17.15 C210.62,18.45 212.27,18.76 213.91,18.9 C217.2,19.25 220.75,20.18 220.75,24.11 C220.75,26.98 218.89,28.73 215.43,29.11 L215.43,31.21 L212.43,31.21 L212.43,29.14 C209.877141,28.9793565 207.611564,27.4485613 206.51,25.14 L209.38,23.75 C210.306579,25.2810927 211.980817,26.200207 213.77,26.16 C215.77,26.16 217.3,25.87 217.3,24.16 C217.28,22.76 215.56,22.19 213.64,22 Z"
              id="Shape"
              fill="#FFFFFF"></path>
            <path
              d="M213.75,26.16 C211.960817,26.200207 210.286579,25.2810927 209.36,23.75 L206.49,25.14 C207.591564,27.4485613 209.857141,28.9793565 212.41,29.14 L212.41,31.22 L215.41,31.22 L215.41,29.12 C218.88,28.77 220.73,27.02 220.73,24.12 C220.73,20.19 217.18,19.26 213.89,18.91 C212.25,18.78 210.62,18.49 210.62,17.16 C210.62,15.83 212.17,15.26 213.73,15.26 C215.152964,15.1761484 216.51694,15.8391923 217.33,17.01 L220.05,15.75 C219.194762,13.9253993 217.40253,12.7216038 215.39,12.62 L215.39,10.82 L212.48,10.82 L212.48,12.65 C209.76,12.87 207.25,14.28 207.22,17.2 C207.22,21.09 210.38,21.73 213.62,22.04 C215.54,22.19 217.26,22.77 217.26,24.16 C217.28,25.88 215.76,26.16 213.75,26.16 Z"
              id="Shape"
              fill={accentColor}></path>
            <path
              d="M343.83,152.87 C344.49,152.94 346.03,152.99 347.66,152.99 L347.66,145.15 L363.66,133.78 L364.34,134.78 L348.85,145.78 L348.85,153 C350.48,153 352.02,153 352.68,152.88 C360.598383,151.957276 367.31151,146.630535 370.009818,139.129112 C372.708126,131.627689 370.926275,123.245252 365.41,117.49 C362.227148,114.001528 360.726024,109.297274 361.3,104.61 C361.333333,104.216667 361.35,103.823333 361.35,103.43 C361.481681,98.6653246 359.014988,94.2051315 354.909207,91.7839679 C350.803426,89.3628044 345.706574,89.3628044 341.600793,91.7839679 C337.495012,94.2051315 335.028319,98.6653246 335.16,103.43 C335.16,103.83 335.176667,104.223333 335.21,104.61 C335.785343,109.297402 334.28404,114.002215 331.1,117.49 C325.583725,123.245252 323.801874,131.627689 326.500182,139.129112 C329.19849,146.630535 335.911617,151.957276 343.83,152.88 L343.83,152.87 Z M361.21,121.46 L362.05,122.28 L354.05,130.47 L353.63,130.06 L353.21,129.65 L361.21,121.46 Z M354.21,109.21 L355.05,110.03 L351.7,113.45 L351.28,113.04 L350.86,112.63 L354.21,109.21 Z M340.43,109.48 L345.59,129.92 L345.02,130.06 L344.45,130.2 L339.29,109.76 L340.43,109.48 Z M331.43,127.58 L331.85,127.17 L343.75,139.34 L342.91,140.16 L331,128 L331.43,127.58 Z"
              id="Shape"
              fill="#E1E5E9"></path>
            <polygon
              id="Shape"
              fill="#C5C9D1"
              points="353.62 130.07 354.04 130.48 362.06 122.29 361.21 121.47 353.2 129.66"></polygon>
            <polygon
              id="Shape"
              fill="#C5C9D1"
              points="343.73 139.34 331.83 127.17 331.4 127.59 330.98 128 342.88 140.17"></polygon>
            <polygon
              id="Shape"
              fill="#C5C9D1"
              points="351.73 113.46 355.07 110.04 354.23 109.22 350.88 112.64 351.3 113.05"></polygon>
            <path
              d="M348.84,154.17 C350.51,154.17 352.1,154.12 352.84,154.04 C361.213389,153.081793 368.318379,147.456645 371.171842,139.526352 C374.025305,131.596058 372.133218,122.733599 366.29,116.66 C363.332323,113.40723 361.950554,109.020663 362.51,104.66 C362.55,104.233333 362.57,103.803333 362.57,103.37 C362.707379,98.1799511 360.017026,93.3242596 355.543811,90.6887651 C351.070596,88.0532706 345.519404,88.0532706 341.046189,90.6887651 C336.572974,93.3242596 333.882621,98.1799511 334.02,103.37 C334.02,103.8 334.02,104.23 334.08,104.66 C334.639446,109.020663 333.257677,113.40723 330.3,116.66 C324.483776,122.728867 322.602063,131.566096 325.441359,139.477986 C328.280655,147.389876 335.352085,153.014139 343.7,154 C344.4,154.08 345.99,154.12 347.7,154.13 L347.7,162 L348.88,163 L348.84,154.17 Z M331.1,117.48 C334.28404,113.992215 335.785343,109.287402 335.21,104.6 C335.21,104.206667 335.193333,103.813333 335.16,103.42 C335.028319,98.6553246 337.495012,94.1951315 341.600793,91.7739679 C345.706574,89.3528044 350.803426,89.3528044 354.909207,91.7739679 C359.014988,94.1951315 361.481681,98.6553246 361.35,103.42 C361.35,103.82 361.333333,104.213333 361.3,104.6 C360.726024,109.287274 362.227148,113.991528 365.41,117.48 C370.926275,123.235252 372.708126,131.617689 370.009818,139.119112 C367.31151,146.620535 360.598383,151.947276 352.68,152.87 C352.02,152.94 350.48,152.99 348.85,152.99 L348.85,145.75 L364.34,134.75 L363.66,133.75 L347.66,145.12 L347.66,153 C346.03,153 344.5,153 343.83,152.88 C335.911617,151.957276 329.19849,146.630535 326.500182,139.129112 C323.801874,131.627689 325.583725,123.245252 331.1,117.49 L331.1,117.48 Z"
              id="Shape"
              fill="#C5C9D1"></path>
            <polygon
              id="Shape"
              fill="#C5C9D1"
              points="345.04 130.07 345.62 129.93 340.45 109.48 339.31 109.77 344.47 130.22"></polygon>
            <path
              d="M19.47,149.5 L19.47,148.94 C19.4874229,145.455281 16.7136742,142.597076 13.23,142.51 C9.76204492,142.61838 7.0120429,145.470398 7.03,148.94 L7.03,149.5 C7.34928516,151.903073 6.60845498,154.326281 5,156.14 C2.33103097,158.921063 1.46767153,162.973925 2.77148745,166.601289 C4.07530338,170.228653 7.32126578,172.804464 11.15,173.25 C11.43,173.25 12.04,173.25 12.73,173.31 L12.73,170.16 L5.15,164.77 L5.83,163.77 L13.91,169.51 L13.91,173.27 C14.6,173.27 15.21,173.27 15.49,173.21 C19.3187342,172.764464 22.5646966,170.188653 23.8685125,166.561289 C25.1723285,162.933925 24.308969,158.881063 21.64,156.1 C19.9923051,154.319654 19.2002918,151.910765 19.47,149.5 L19.47,149.5 Z M10.18,162.61 L6.18,158.53 L7.02,157.71 L11.02,161.79 L10.18,162.61 Z M11.75,153.73 L11.33,154.14 L9.66,152.44 L10.08,152.03 L10.5,151.62 L12.17,153.32 L11.75,153.73 Z M16.86,151.88 L17.43,152.02 L18,152.16 L15.43,162.33 L14.29,162.04 L16.86,151.88 Z M22.07,161.37 L16.15,167.42 L15.73,167.01 L15.31,166.6 L21.23,160.55 L21.65,160.96 L22.07,161.37 Z"
              id="Shape"
              fill="#E1E5E9"></path>
            <path
              d="M20.65,149.6 L20.65,148.93 C20.6618238,144.797604 17.3614929,141.417211 13.23,141.33 C9.11420789,141.438616 5.83770368,144.812793 5.85,148.93 L5.85,149.6 C6.1116654,151.677821 5.45439956,153.766465 4.05,155.32 C1.05735609,158.433148 0.0965900363,162.977723 1.5731879,167.035712 C3.04978576,171.0937 6.70648667,173.958097 11,174.42 C11.31,174.42 12,174.48 12.71,174.48 L12.71,180.76 L13.89,180.76 L13.89,174.48 C14.62,174.48 15.28,174.48 15.6,174.42 C19.879421,173.931779 23.5109862,171.057276 24.9687849,167.004299 C26.4265836,162.951321 25.4579948,158.422207 22.47,155.32 C21.0583937,153.769873 20.3936966,151.680825 20.65,149.6 L20.65,149.6 Z M24.32,164.7 C23.6024025,169.208161 19.9821169,172.693758 15.45,173.24 C15.17,173.24 14.56,173.24 13.87,173.3 L13.87,169.54 L5.79,163.8 L5.11,164.8 L12.69,170.19 L12.69,173.34 C12,173.34 11.39,173.34 11.11,173.28 C7.2757567,172.829982 4.02876417,170.243776 2.73246733,166.607356 C1.43617049,162.970935 2.31502849,158.913962 5,156.14 C6.64084688,154.341549 7.415093,151.916552 7.12,149.5 L7.12,148.94 C7.1020429,145.470398 9.85204492,142.61838 13.32,142.51 C16.8036742,142.597076 19.5774229,145.455281 19.56,148.94 L19.56,149.5 C19.2675824,151.918057 20.045546,154.343258 21.69,156.14 C23.8454172,158.4356 24.8133131,161.60158 24.31,164.71 L24.32,164.7 Z"
              id="Shape"
              fill="#C5C9D1"></path>
            <rect
              id="Rectangle-path"
              fill="#C5C9D1"
              transform="translate(8.611169, 160.158822) rotate(-44.370000) translate(-8.611169, -160.158822) "
              x="8.02116916"
              y="157.308822"
              width="1.18"
              height="5.7"></rect>
            <polygon
              id="Shape"
              fill="#C5C9D1"
              points="15.31 166.61 15.73 167.02 16.16 167.43 22.08 161.38 21.66 160.96 21.23 160.55"></polygon>
            <polygon
              id="Shape"
              fill="#C5C9D1"
              points="10.09 152.03 9.67 152.44 11.33 154.14 11.76 153.73 12.18 153.32 10.51 151.62"></polygon>
            <polygon
              id="Shape"
              fill="#C5C9D1"
              points="18.01 152.17 17.44 152.03 16.87 151.88 14.3 162.06 15.44 162.34"></polygon>
            <path
              d="M86.61,179.52 L87.01,179.52 C87.7984956,179.409442 88.5774181,179.238948 89.34,179.01 L89.34,163.34 L89.34,163.34 L89.82,162.96 L86.61,164.49 L86.61,179.52 Z"
              id="Shape"
              fill="#E1E5E9"></path>
            <path
              d="M103.4,161.45 C103.4,161.27 103.47,161.08 103.49,160.9 C104.425496,154.245119 102.593145,147.497585 98.42,142.23 C96.4106595,139.665388 95.1724573,136.582022 94.85,133.34 L94.85,133.21 L94.85,133.09 C95.1260916,132.23306 95.3235737,131.352758 95.44,130.46 C95.624364,129.069417 95.624364,127.660583 95.44,126.27 L83.87,132.27 L83.87,161.08 L84.12,161.28 L84.12,161.28 L86.5,163.2 L97.54,158 L98.05,159.06 L93.51,161.23 L93.67,161.36 L93.67,161.36 L95.91,163.16 L96.18,163.38 L96.18,175.17 C97.1817753,174.283058 98.0959791,173.30188 98.91,172.24 L98.91,163.38 L101.11,161.61 L102.33,160.61 L103.24,161.34 L103.24,161.34 L103.4,161.45 Z"
              id="Shape"
              fill="#E1E5E9"></path>
            <path
              d="M64,148.62 C62.5425348,152.538788 62.0620054,156.753717 62.6,160.9 C62.6,161.09 62.66,161.28 62.69,161.47 L63.78,160.59 L64.69,161.32 L64.69,161.32 L67.07,163.24 L67.19,163.34 L67.19,163.34 L67.19,172.23 C68.076554,173.385507 69.082075,174.444656 70.19,175.39 L70.19,163.39 L70.19,163.39 L71.91,162 L73.62,160.62 L74.53,161.35 L74.53,161.35 L76.88,163.24 L77.04,163.37 L77.04,163.37 L77.04,179.08 C77.6967905,179.26348 78.3648849,179.40378 79.04,179.5 L79.73,179.56 L79.73,163.34 L79.73,163.34 L80.57,162.66 L82.67,161 L82.67,160.69 L64,148.62 Z"
              id="Shape"
              fill="#E1E5E9"></path>
            <path
              d="M91.56,117.88 C90.3252042,115.667002 89.7818377,113.134775 90,110.61 L90,109.85 C90,105.19 86.9,101.43 83,101.29 C79.09,101.43 76,105.19 76,109.85 L76,110.61 C76.233882,113.101457 75.7259252,115.606449 74.54,117.81 C74.1523027,118.304543 73.7949791,118.822161 73.47,119.36 C71.0887158,122.53781 70.0541226,126.525305 70.59,130.46 C70.7062073,131.352797 70.9036938,132.233119 71.18,133.09 L71.18,133.21 L71.18,133.34 C70.8575427,136.582022 69.6193405,139.665388 67.61,142.23 C66.2973857,143.832429 65.2136988,145.609406 64.39,147.51 L82.6,159.29 L82.6,143 L74.17,138.06 L74.77,137.06 L82.61,141.65 L82.61,107.65 L83.79,107.65 L83.79,131 L95.14,125.07 C94.704513,123.02338 93.8236524,121.097778 92.56,119.43 C92.2587803,118.893308 91.9248157,118.375663 91.56,117.88 Z"
              id="Shape"
              fill="#E1E5E9"></path>
            <path
              d="M62.17,161.89 L62.7,161.47 C62.7,161.28 62.63,161.1 62.61,160.9 C62.0688167,156.754529 62.5459112,152.539622 64,148.62 L82.67,160.7 L82.67,161 L83.19,160.58 L83.85,161.11 L83.85,132.32 L95.42,126.32 C95.604364,127.710583 95.604364,129.119417 95.42,130.51 C95.3035737,131.402758 95.1060916,132.28306 94.83,133.14 L94.83,133.26 L94.83,133.39 C95.1524573,136.632022 96.3906595,139.715388 98.4,142.28 C102.573145,147.547585 104.405496,154.295119 103.47,160.95 C103.47,161.14 103.41,161.32 103.38,161.5 L103.38,161.5 L103.89,161.91 L104.42,162.33 C104.49,161.91 104.57,161.5 104.63,161.08 C105.606703,154.102113 103.680269,147.028885 99.3,141.51 C97.4502541,139.145488 96.3063042,136.306412 96,133.32 C96.2747366,132.435447 96.4721447,131.528708 96.59,130.61 C97.1768825,126.41974 96.1000442,122.166228 93.59,118.76 C93.2715537,118.226693 92.9174127,117.715527 92.53,117.23 C91.4607438,115.23311 91.0050182,112.964919 91.22,110.71 L91.22,109.86 C91.22,104.56 87.62,100.28 82.99,100.12 C78.4,100.28 74.81,104.56 74.81,109.86 L74.81,110.71 C75.0246002,112.936707 74.5868139,115.177755 73.55,117.16 C73.1597982,117.652695 72.8023629,118.170475 72.48,118.71 C69.9312398,122.122498 68.8251259,126.399711 69.4,130.62 C69.517305,131.538803 69.7147235,132.445589 69.99,133.33 C69.6811132,136.30492 68.5409551,139.132789 66.7,141.49 C62.3606017,147.004487 60.4606739,154.051557 61.44,161 C61.49,161.43 61.57,161.85 61.65,162.27 L61.8,162.15 L62.17,161.89 Z M83.85,131 L83.85,107.67 L82.67,107.67 L82.67,141.67 L74.83,137.08 L74.23,138.08 L82.67,143 L82.67,159.28 L64.46,147.51 C65.2836988,145.609406 66.3673857,143.832429 67.68,142.23 C69.6893405,139.665388 70.9275427,136.582022 71.25,133.34 L71.25,133.21 L71.25,133.09 C70.9736938,132.233119 70.7762073,131.352797 70.66,130.46 C70.1241226,126.525305 71.1587158,122.53781 73.54,119.36 C73.8649791,118.822161 74.2223027,118.304543 74.61,117.81 C75.7959252,115.606449 76.303882,113.101457 76.07,110.61 L76.07,109.85 C76.07,105.19 79.17,101.43 83.07,101.29 C87.07,101.43 90.07,105.19 90.07,109.85 L90.07,110.61 C89.8366339,113.129717 90.3625191,115.661628 91.58,117.88 C91.9650107,118.370793 92.3190315,118.885126 92.64,119.42 C93.9036524,121.087778 94.784513,123.01338 95.22,125.06 L83.85,131 Z"
              id="Shape"
              fill="#C5C9D1"></path>
            <path
              d="M89.34,179 C88.5774181,179.228948 87.7984956,179.399442 87.01,179.51 L86.61,179.51 L86.61,180.69 L87.16,180.69 C87.8958508,180.588562 88.6241291,180.43823 89.34,180.24 L89.34,179 L89.34,179 Z"
              id="Shape"
              fill="#C5C9D1"></path>
            <path
              d="M79.77,179.53 L79.08,179.47 C78.4048849,179.37378 77.7367905,179.23348 77.08,179.05 L77.08,180.27 C77.7056567,180.429921 78.3400529,180.553462 78.98,180.64 C79.18,180.64 79.48,180.64 79.82,180.71 L79.82,179.53 L79.77,179.53 Z"
              id="Shape"
              fill="#C5C9D1"></path>
            <path
              d="M70.21,175.39 C69.102075,174.444656 68.096554,173.385507 67.21,172.23 L67.21,172.23 L67.21,174.07 C68.1172613,175.104022 69.1218882,176.048372 70.21,176.89 L70.21,175.38 L70.21,175.39 Z"
              id="Shape"
              fill="#C5C9D1"></path>
            <path
              d="M98.91,172.21 C98.0959791,173.27188 97.1817753,174.253058 96.18,175.14 L96.18,176.69 C97.1658144,175.891937 98.0793509,175.008518 98.91,174.05 L98.91,172.2 L98.91,172.21 Z"
              id="Shape"
              fill="#C5C9D1"></path>
            <polygon
              id="Shape"
              fill="#C5C9D1"
              points="97.55 157.96 86.48 163.24 86.49 163.25 86.61 163.34 86.61 164.49 89.82 162.96 90.18 162.67 92.76 160.59 93.51 161.2 98.05 159.03"></polygon>
            <path
              d="M421.5,151.7 L421.5,151.57 L421.5,151.45 C421.664352,150.938449 421.781508,150.412921 421.85,149.88 C421.933387,149.155726 421.933387,148.424274 421.85,147.7 L415.19,151.18 L415.19,170.37 L423.24,166.53 L423.75,167.59 L415.19,171.67 L415.19,179.73 C415.92,179.73 416.57,179.73 416.86,179.66 C421.86,179.01 426.01,174.32 426.74,168.49 C427.306203,164.480595 426.203807,160.41438 423.69,157.24 C422.452213,155.636782 421.693005,153.716228 421.5,151.7 Z"
              id="Shape"
              fill="#E1E5E9"></path>
            <path
              d="M403,161.38 C402.197326,163.665642 401.940482,166.107367 402.25,168.51 C402.98,174.33 407.14,179.03 412.13,179.68 C412.46,179.68 413.23,179.75 414.06,179.75 L414.06,168.54 L403,161.38 Z"
              id="Shape"
              fill="#E1E5E9"></path>
            <path
              d="M414,167.13 L414,157.72 L409,154.72 L409.6,153.72 L414.05,156.33 L414.05,136 L415.23,136 L415.23,149.89 L421.69,146.52 C421.419536,145.363138 420.908443,144.276213 420.19,143.33 C419.992851,143.00361 419.775773,142.689682 419.54,142.39 C418.750897,140.98877 418.40241,139.382248 418.54,137.78 L418.54,137.33 C418.54,134.6 416.74,132.4 414.45,132.33 C412.2,132.41 410.45,134.61 410.45,137.33 L410.45,137.78 C410.595764,139.347631 410.275736,140.923424 409.53,142.31 C409.289952,142.62966 409.069546,142.963609 408.87,143.31 C407.436532,145.210627 406.814476,147.60177 407.14,149.96 C407.208657,150.492892 407.32581,151.018405 407.49,151.53 L407.49,151.65 L407.49,151.78 C407.29013,153.807591 406.51659,155.736238 405.26,157.34 C404.517635,158.254894 403.898984,159.263565 403.42,160.34 L414,167.13 Z"
              id="Shape"
              fill="#E1E5E9"></path>
            <path
              d="M424.65,156.51 C423.545685,155.118172 422.852896,153.445086 422.65,151.68 C422.815025,151.131174 422.93213,150.569067 423,150 C423.361787,147.381096 422.683321,144.724667 421.11,142.6 C420.919008,142.272025 420.705145,141.957913 420.47,141.66 C419.838422,140.477375 419.570531,139.13444 419.7,137.8 L419.7,137.26 C419.7,133.9 417.4,131.18 414.43,131.07 C411.5,131.17 409.2,133.89 409.2,137.26 L409.2,137.8 C409.328613,139.106248 409.07867,140.421917 408.48,141.59 C408.24248,141.891883 408.025333,142.209252 407.83,142.54 C406.268286,144.691845 405.611381,147.369722 406,150 C406.072639,150.559275 406.19308,151.111295 406.36,151.65 C406.158148,153.415356 405.465244,155.088719 404.36,156.48 C401.642273,159.9073 400.446173,164.297816 401.05,168.63 C401.85,174.98 406.43,180.1 411.95,180.82 C412.39,180.88 413.44,180.9 414.5,180.9 C415.56,180.9 416.61,180.9 417.05,180.82 C422.57,180.1 427.15,174.98 427.95,168.63 C428.548151,164.309067 427.356168,159.931242 424.65,156.51 Z M426.79,168.51 C426.06,174.33 421.9,179.03 416.91,179.68 C416.61,179.68 415.97,179.74 415.24,179.75 L415.24,171.69 L423.8,167.61 L423.29,166.55 L415.24,170.39 L415.24,151.19 L421.9,147.71 C421.983387,148.434274 421.983387,149.165726 421.9,149.89 C421.831508,150.422921 421.714352,150.948449 421.55,151.46 L421.55,151.58 L421.55,151.71 C421.750953,153.737325 422.524376,155.665681 423.78,157.27 C426.276944,160.448025 427.364566,164.509444 426.79,168.51 L426.79,168.51 Z M412.12,179.68 C407.12,179.03 402.97,174.34 402.24,168.51 C401.930482,166.107367 402.187326,163.665642 402.99,161.38 L414,168.54 L414,179.75 C413.21,179.74 412.45,179.72 412.11,179.67 L412.12,179.68 Z M407.52,151.68 L407.52,151.55 L407.52,151.43 C407.35581,150.918405 407.238657,150.392892 407.17,149.86 C406.844476,147.50177 407.466532,145.110627 408.9,143.21 C409.099546,142.863609 409.319952,142.52966 409.56,142.21 C410.305736,140.823424 410.625764,139.247631 410.48,137.68 L410.48,137.23 C410.48,134.5 412.28,132.3 414.48,132.23 C416.77,132.31 418.57,134.51 418.57,137.23 L418.57,137.68 C418.43241,139.282248 418.780897,140.88877 419.57,142.29 C419.805773,142.589682 420.022851,142.90361 420.22,143.23 C420.938443,144.176213 421.449536,145.263138 421.72,146.42 L415.26,149.79 L415.26,136 L414,136 L414,156.39 L409.55,153.78 L408.95,154.78 L413.95,157.78 L413.95,167.19 L403.34,160.32 C403.818984,159.243565 404.437635,158.234894 405.18,157.32 C406.483104,155.71099 407.292366,153.759037 407.51,151.7 L407.52,151.68 Z"
              id="Shape"
              fill="#C5C9D1"></path>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="273.6 79.97 276.02 79.97 276.02 79.49 275.58 79.49 271.62 79.49 269.64 79.49 269.24 79.49 269.24 79.97 269.64 79.97"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="273.6 75.25 276.02 75.25 276.02 74.77 275.58 74.77 271.62 74.77 269.64 74.77 269.24 74.77 269.24 75.25 269.64 75.25"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="271.62 72.88 275.58 72.88 276.02 72.88 276.02 72.4 273.6 72.4 269.64 72.4 269.24 72.4 269.24 72.88 269.64 72.88"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="271.62 77.61 275.58 77.61 276.02 77.61 276.02 77.13 273.6 77.13 269.64 77.13 269.24 77.13 269.24 77.61 269.64 77.61"></polygon>
            <rect
              id="Rectangle-path"
              fill="#FFFFFF"
              x="275.69"
              y="70.04"
              width="0.33"
              height="0.48"></rect>
            <rect
              id="Rectangle-path"
              fill="#FFFFFF"
              x="269.24"
              y="70.04"
              width="0.27"
              height="0.48"></rect>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="273.6 76.19 273.6 77.13 276.02 77.13 276.02 76.19 276.02 75.25 273.6 75.25"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="273.6 75.25 269.64 75.25 269.64 76.19 269.64 77.13 273.6 77.13 273.6 76.19"></polygon>
            <rect
              id="Rectangle-path"
              fill="#EDEEF0"
              x="271.62"
              y="72.88"
              width="3.96"
              height="1.88"></rect>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="275.58"
              y="72.88"
              width="0.44"
              height="1.88"></rect>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="271.62 74.77 271.62 72.88 269.64 72.88 269.24 72.88 269.24 74.77 269.64 74.77"></polygon>
            <rect
              id="Rectangle-path"
              fill="#EDEEF0"
              x="269.65"
              y="72.11"
              width="3.96"
              height="0.3"></rect>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="275.69 72.11 273.6 72.11 273.6 72.4 276.02 72.4 276.02 70.52 275.69 70.52"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="275.69 69.95 275.69 70.04 276.02 70.04 276.02 69.69 275.58 69.69 275.58 69.95"></polygon>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="271.62"
              y="69.68"
              width="3.96"
              height="0.26"></rect>
            <rect
              id="Rectangle-path"
              fill="#EDEEF0"
              x="269.65"
              y="79.97"
              width="3.96"
              height="1.71"></rect>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="273.6"
              y="79.97"
              width="2.42"
              height="1.71"></rect>
            <rect
              id="Rectangle-path"
              fill="#EDEEF0"
              x="275.58"
              y="77.61"
              width="0.44"
              height="1.88"></rect>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="271.62 79.49 271.62 77.61 269.64 77.61 269.24 77.61 269.24 79.49 269.64 79.49"></polygon>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="271.62"
              y="77.61"
              width="3.96"
              height="1.88"></rect>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="269.64 72.11 269.51 72.11 269.51 70.52 269.24 70.52 269.24 72.4 269.64 72.4"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="269.51 69.95 269.64 69.95 271.62 69.95 271.62 69.69 269.64 69.69 269.24 69.69 269.24 70.04 269.51 70.04"></polygon>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="269.24"
              y="79.97"
              width="0.41"
              height="1.71"></rect>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="269.64 76.19 269.64 75.25 269.24 75.25 269.24 76.19 269.24 77.13 269.64 77.13"></polygon>
            <path
              d="M247.76,131.35 L247.68,131.35 L247.76,131.35 Z"
              id="Shape"
              fill="#E1E5E9"></path>
            <path
              d="M232.24,164.62 L232.24,164 L234.34,164 L236.47,134.24 L191.11,134.24 L191.11,131.4 L190.66,131.4 L193,164 L195.1,164 L195.1,165.18 L193,165.18 L193,172 L203.44,172 L203.44,135.43 C203.44,135.104152 203.704152,134.84 204.03,134.84 L223.26,134.84 C223.585848,134.84 223.85,135.104152 223.85,135.43 L223.85,172 L234.29,172 L234.29,165.22 L232.23,165.22 L232.24,164.62 Z"
              id="Shape"
              fill="#E1E5E9"></path>
            <path
              d="M294.6,164.62 L294.6,164 L296.7,164 L298.83,134.24 L243.93,134.24 L246.06,164 L248.16,164 L248.16,165.18 L246.1,165.18 L246.1,172 L296.66,172 L296.66,165.22 L294.6,165.22 L294.6,164.62 Z M251.6,161.38 L253.66,161.38 L253.66,138.09 C253.66,137.933522 253.722161,137.783453 253.832807,137.672807 C253.943453,137.562161 254.093522,137.5 254.25,137.5 L288.75,137.5 C288.906478,137.5 289.056547,137.562161 289.167193,137.672807 C289.277839,137.783453 289.34,137.933522 289.34,138.09 L289.34,161.38 L291.4,161.38 L291.4,162.56 L251.6,162.56 L251.6,161.38 Z"
              id="Shape"
              fill="#E1E5E9"></path>
            <path
              d="M179.17,164.62 L179.17,164 L181.27,164 L183.4,134.24 L128.5,134.24 L130.63,164 L132.74,164 L132.74,165.18 L130.68,165.18 L130.68,172 L181.25,172 L181.25,165.22 L179.19,165.22 L179.17,164.62 Z M136.71,161.38 L138.77,161.38 L138.77,138.09 C138.77,137.933522 138.832161,137.783453 138.942807,137.672807 C139.053453,137.562161 139.203522,137.5 139.36,137.5 L173.86,137.5 C174.016478,137.5 174.166547,137.562161 174.277193,137.672807 C174.387839,137.783453 174.45,137.933522 174.45,138.09 L174.45,161.38 L176.51,161.38 L176.51,162.56 L136.71,162.56 L136.71,161.38 Z"
              id="Shape"
              fill="#E1E5E9"></path>
            <path
              d="M179.27,130.86 L179.27,130.86 C179.263507,130.909789 179.263507,130.960211 179.27,131.01 C179.263507,130.960211 179.263507,130.909789 179.27,130.86 L179.27,130.86 Z"
              id="Shape"
              fill="#E1E5E9"></path>
            <polygon
              id="Shape"
              fill="#E1E5E9"
              points="247.49 131.43 247.49 131.43 247.57 131.43 247.47 131.43 247.47 131.43"></polygon>
            <polygon
              id="Shape"
              fill="#E1E5E9"
              points="248 131.09 248 131.09 248 131.03"></polygon>
            <path
              d="M248.06,130.87 L248.06,130.87 L248.06,130.87 C248.06,130.87 248.06,130.86 248.06,130.87 Z"
              id="Shape"
              fill="#E1E5E9"></path>
            <path
              d="M183.6,131.43 L179.81,131.43 L179.65,131.43 L179.65,131.43 L179.65,131.43 L179.65,131.43 L179.57,131.36 L179.57,131.36 L179.52,131.29 L179.52,131.29 C179.51707,131.256731 179.51707,131.223269 179.52,131.19 C179.513507,131.140211 179.513507,131.089789 179.52,131.04 L179.52,131.04 L179.52,130.92 L128.52,130.92 L128.77,134.47 L183.67,134.47 L183.6,131.43 Z"
              id="Shape"
              fill="#C9CFD4"></path>
            <polygon
              id="Shape"
              fill="#E1E5E9"
              points="296.66 174.95 296.66 174.36 296.66 173.77 296.66 173.17 246.1 173.17 246.1 173.77 246.1 174.36 246.1 174.95 246.1 179.95 296.66 179.95"></polygon>
            <polygon
              id="Shape"
              fill="#E1E5E9"
              points="181.24 174.95 181.24 174.36 181.24 173.77 181.24 173.17 130.67 173.17 130.67 173.77 130.67 174.36 130.67 174.95 130.67 179.95 181.24 179.95"></polygon>
            <polygon
              id="Shape"
              fill="#E1E5E9"
              points="223.28 173.17 204.05 173.17 193.03 173.17 193.03 173.77 193.03 174.36 193.03 174.95 193.03 177.3 234.31 177.3 234.31 174.95 234.31 174.36 234.31 173.77 234.31 173.17"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="234.31 180.54 234.31 179.95 234.31 178.48 193.03 178.48 193.03 179.95 193.03 180.54 193.03 181.13 193.03 182.61 234.31 182.61 234.31 181.13"></polygon>
            <path
              d="M299.08,130.72 L248.08,130.72 L248.08,130.84 L248.08,130.84 C248.084149,130.879892 248.084149,130.920108 248.08,130.96 L248.08,131.01 L248.08,131.07 L248.08,131.07 C248.049929,131.118509 248.012863,131.162315 247.97,131.2 L247.97,131.2 L247.97,131.2 L247.97,131.2 L247.97,131.2 L247.89,131.2 L247.79,131.2 L247.71,131.2 L243.94,131.2 L244.02,132.36 L244.14,134.04 L299.04,134.04 L299.08,130.72 Z"
              id="Shape"
              fill="#C9CFD4"></path>
            <polygon
              id="Shape"
              fill="#C9CFD4"
              points="236.47 134.27 236.68 131.43 191.11 131.43 191.11 134.27"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="242.55 131.43 237.86 131.43 235.53 164.03 244.88 164.03"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="189.48 131.43 184.79 131.43 182.46 164.03 191.81 164.03"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="124.99 164.03 125.58 164.03 126.16 164.03 129.45 164.03 127.07 130.72 126.16 130.72 125.58 130.72 124.99 130.72 122.48 130.72 120.1 164.03"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="303.36 130.72 302.77 130.72 302.18 130.72 300.27 130.72 297.89 164.03 302.18 164.03 302.77 164.03 303.36 164.03 307.24 164.03 304.86 130.72"></polygon>
            <path
              d="M246.1,95.72 L246.1,114.2 C246.1,114.525848 245.835848,114.79 245.51,114.79 L243.28,114.79 L243.28,122.72 L242.82,122.72 L245.47,124.13 L248.76,124.13 L248.76,83.69 L249.94,83.69 L249.94,124.14 L255.42,124.14 L255.42,82.86 L248.76,82.86 L248.76,93 C248.76,93.325848 248.495848,93.59 248.17,93.59 L246.17,93.59 L246.17,95.75 L246.1,95.72 Z"
              id="Shape"
              fill="#FFFFFF"></path>
            <rect
              id="Rectangle-path"
              fill="#FFFFFF"
              x="256.59"
              y="82.86"
              width="5.48"
              height="41.28"></rect>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="193.53 117.93 199.43 114.8 193.53 114.8 193.53 117.93"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="268.73 124.14 268.73 90.91 268.73 90.32 268.73 85.63 268.73 82.86 268.65 82.86 268.06 82.86 263.25 82.86 263.25 124.14"></polygon>
            <rect
              id="Rectangle-path"
              fill="#FFFFFF"
              x="126.96"
              y="82.86"
              width="5.48"
              height="41.28"></rect>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="192.35 118.56 192.35 114.8 186.87 114.8 186.87 121.47"></polygon>
            <rect
              id="Rectangle-path"
              fill="#FFFFFF"
              x="303.19"
              y="82.86"
              width="4.93"
              height="41.28"></rect>
            <rect
              id="Rectangle-path"
              fill="#FFFFFF"
              x="120.89"
              y="82.86"
              width="4.89"
              height="41.28"></rect>
            <rect
              id="Rectangle-path"
              fill="#FFFFFF"
              x="296.53"
              y="82.86"
              width="5.48"
              height="41.28"></rect>
            <rect
              id="Rectangle-path"
              fill="#FFFFFF"
              x="289.88"
              y="82.86"
              width="5.48"
              height="41.28"></rect>
            <path
              d="M181.86,124.14 L185.69,122.14 L185.69,114.84 L181.82,114.84 C181.494152,114.84 181.23,114.575848 181.23,114.25 L181.23,95.72 L181.14,95.72 L181.14,93.57 L180.21,93.57 L180.21,124.14 L181.86,124.14 Z"
              id="Shape"
              fill="#FFFFFF"></path>
            <rect
              id="Rectangle-path"
              fill="#FFFFFF"
              x="283.22"
              y="82.86"
              width="5.48"
              height="41.28"></rect>
            <rect
              id="Rectangle-path"
              fill="#FFFFFF"
              x="140.28"
              y="82.86"
              width="5.48"
              height="41.28"></rect>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="227.9 114.8 235.44 118.8 235.44 114.8"></polygon>
            <rect
              id="Rectangle-path"
              fill="#FFFFFF"
              x="153.59"
              y="82.86"
              width="5.48"
              height="41.28"></rect>
            <rect
              id="Rectangle-path"
              fill="#FFFFFF"
              x="146.93"
              y="82.86"
              width="5.48"
              height="41.28"></rect>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="236.62 114.8 236.62 119.31 236.39 119.31 242.1 122.34 242.1 114.8"></polygon>
            <rect
              id="Rectangle-path"
              fill="#FFFFFF"
              x="160.25"
              y="82.86"
              width="5.48"
              height="41.28"></rect>
            <rect
              id="Rectangle-path"
              fill="#FFFFFF"
              x="166.9"
              y="82.86"
              width="5.48"
              height="41.28"></rect>
            <path
              d="M179,124.14 L179,93.55 L179,93.55 C178.738535,93.4898774 178.552428,93.2582775 178.55,92.99 L178.55,82.86 L173.55,82.86 L173.55,124.14 L179,124.14 Z"
              id="Shape"
              fill="#FFFFFF"></path>
            <rect
              id="Rectangle-path"
              fill="#FFFFFF"
              x="133.62"
              y="82.86"
              width="5.48"
              height="41.28"></rect>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="269.91 89.73 269.91 90.32 269.91 90.91 269.91 124.14 275.38 124.14 275.38 90.91 275.38 90.32 275.38 89.73 275.38 85.63 275.38 82.86 269.91 82.86 269.91 85.63"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="276.56 90.32 276.56 90.91 276.56 124.14 282.04 124.14 282.04 82.86 277.2 82.86 276.61 82.86 276.56 82.86 276.56 85.63"></polygon>
            <path
              d="M182.41,113.62 L201.64,113.62 L213.38,107.38 C213.552121,107.289322 213.757879,107.289322 213.93,107.38 L225.67,113.62 L244.9,113.62 L244.9,95.72 L182.41,95.72 L182.41,113.62 Z M223.69,98.29 C223.69,97.964152 223.954152,97.7 224.28,97.7 L240.2,97.7 C240.356478,97.7 240.506547,97.7621605 240.617193,97.872807 C240.727839,97.9834535 240.79,98.1335223 240.79,98.29 L240.79,108.9 C240.79,109.056478 240.727839,109.206547 240.617193,109.317193 C240.506547,109.427839 240.356478,109.49 240.2,109.49 L224.28,109.49 C223.954152,109.49 223.69,109.225848 223.69,108.9 L223.69,98.29 Z M186.54,98.29 C186.54,97.964152 186.804152,97.7 187.13,97.7 L203.05,97.7 C203.206478,97.7 203.356547,97.7621605 203.467193,97.872807 C203.577839,97.9834535 203.64,98.1335223 203.64,98.29 L203.64,108.9 C203.64,109.225848 203.375848,109.49 203.05,109.49 L187.13,109.49 C186.804152,109.49 186.54,109.225848 186.54,108.9 L186.54,98.29 Z"
              id="Shape"
              fill="#E1E5E9"></path>
            <rect
              id="Rectangle-path"
              fill="#C5C9D1"
              x="232.83"
              y="98.87"
              width="6.78"
              height="9.43"></rect>
            <rect
              id="Rectangle-path"
              fill="#C5C9D1"
              x="224.87"
              y="98.87"
              width="6.78"
              height="9.43"></rect>
            <path
              d="M224.28,109.49 L240.2,109.49 C240.525848,109.49 240.79,109.225848 240.79,108.9 L240.79,98.28 C240.79,98.1235223 240.727839,97.9734535 240.617193,97.862807 C240.506547,97.7521605 240.356478,97.69 240.2,97.69 L224.28,97.69 C223.954152,97.69 223.69,97.954152 223.69,98.28 L223.69,108.9 C223.69,109.225848 223.954152,109.49 224.28,109.49 L224.28,109.49 Z M239.61,108.31 L232.83,108.31 L232.83,98.88 L239.61,98.88 L239.61,108.31 Z M224.87,98.88 L231.65,98.88 L231.65,108.31 L224.87,108.31 L224.87,98.88 Z"
              id="Shape"
              fill="#4C5A68"></path>
            <rect
              id="Rectangle-path"
              fill="#C5C9D1"
              x="195.68"
              y="98.87"
              width="6.78"
              height="9.43"></rect>
            <rect
              id="Rectangle-path"
              fill="#C5C9D1"
              x="187.72"
              y="98.87"
              width="6.78"
              height="9.43"></rect>
            <path
              d="M187.13,109.49 L203.05,109.49 C203.375848,109.49 203.64,109.225848 203.64,108.9 L203.64,98.28 C203.64,97.954152 203.375848,97.69 203.05,97.69 L187.13,97.69 C186.804152,97.69 186.54,97.954152 186.54,98.28 L186.54,108.9 C186.54,109.225848 186.804152,109.49 187.13,109.49 Z M202.46,108.31 L195.68,108.31 L195.68,98.88 L202.46,98.88 L202.46,108.31 Z M187.72,98.88 L194.5,98.88 L194.5,108.31 L187.72,108.31 L187.72,98.88 Z"
              id="Shape"
              fill="#4C5A68"></path>
            <path
              d="M308.12,125.41 L247.82,125.41 C247.971734,125.514861 248.064548,125.685638 248.07,125.87 L248.07,129.54 L308.07,129.54 L308.12,125.41 Z"
              id="Shape"
              fill="#E1E5E9"></path>
            <path
              d="M122,129.54 L179.29,129.54 L179.29,125.87 C179.295452,125.685638 179.388266,125.514861 179.54,125.41 L120.89,125.41 L120.89,129.54 L122,129.54 Z"
              id="Shape"
              fill="#E1E5E9"></path>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="243.05 130.2 242.46 130.2 240.84 130.2 240.71 130.13 239.6 129.54 238.05 128.72 237.48 128.41 236.96 128.14 236.91 128.11 235.85 127.55 234.75 126.96 231.83 125.41 231.66 125.31 230.72 124.82 230.55 124.72 229.62 124.23 229.44 124.14 213.67 115.75 197.9 124.14 197.72 124.23 196.79 124.72 196.61 124.82 195.68 125.31 195.5 125.41 192.59 126.96 191.48 127.55 190.42 128.11 190.37 128.14 189.85 128.41 189.28 128.72 187.74 129.54 186.63 130.13 186.49 130.2 184.87 130.2 184.28 130.2 183.69 130.2 182.31 130.2 182.22 130.25 183.69 130.25 184.28 130.25 184.87 130.25 189.39 130.25 189.98 130.25 190.57 130.25 236.76 130.25 237.35 130.25 237.94 130.25 242.46 130.25 243.05 130.25 243.65 130.25 245.12 130.25 245.02 130.2 243.64 130.2"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="193.54 124.23 192.61 124.72 192.43 124.82 191.5 125.31 191.32 125.41 188.55 126.88 188.41 126.96 187.44 127.47 187.3 127.55 186.33 128.06 186.19 128.14 184.97 128.78 184.36 129.11 183.75 129.44 183.56 129.54 182.45 130.13 182.31 130.2 183.69 130.2 184.28 130.2 184.87 130.2 186.49 130.2 186.63 130.13 187.74 129.54 189.28 128.72 189.85 128.41 190.37 128.14 190.42 128.11 191.48 127.55 192.59 126.96 195.5 125.41 195.68 125.31 196.61 124.82 196.79 124.72 197.72 124.23 197.9 124.14 213.67 115.75 229.44 124.14 229.62 124.23 230.55 124.72 230.72 124.82 231.66 125.31 231.83 125.41 234.75 126.96 235.85 127.55 236.91 128.11 236.96 128.14 237.48 128.41 238.05 128.72 239.6 129.54 240.71 130.13 240.84 130.2 242.46 130.2 243.05 130.2 243.64 130.2 245.02 130.2 244.89 130.13 243.78 129.54 243.59 129.44 242.97 129.11 242.36 128.78 241.14 128.14 241 128.06 240.03 127.55 239.9 127.47 238.93 126.96 238.79 126.88 236.01 125.41 235.84 125.31 234.9 124.82 234.73 124.72 233.79 124.23 233.62 124.14 216.05 114.8 214.94 114.2 213.83 113.61 213.67 113.53 213.5 113.61 212.4 114.2 211.29 114.8 193.72 124.14"></polygon>
            <path
              d="M180.44,129.86 L181.04,129.54 L183.67,128.14 L183.84,128.05 L184.45,127.72 L184.78,127.55 L184.92,127.48 L185.92,126.96 L186.06,126.89 L187.23,126.27 L188.84,125.42 L189.02,125.33 L189.95,124.83 L190.13,124.74 L191.06,124.24 L191.24,124.15 L194.87,122.22 L208.81,114.81 L209.92,114.22 L211.03,113.63 L213.43,112.36 C213.602121,112.269322 213.807879,112.269322 213.98,112.36 L216.38,113.63 L217.49,114.22 L218.6,114.81 L232.54,122.22 L236.17,124.15 L236.35,124.24 L237.28,124.74 L237.46,124.83 L238.39,125.33 L238.57,125.42 L240.18,126.28 L241.34,126.9 L241.48,126.97 L242.48,127.49 L242.62,127.56 L242.95,127.73 L243.56,128.06 L243.73,128.15 L246.36,129.55 L246.96,129.87 L246.96,126.24 L245.43,125.42 L245.25,125.33 L244.32,124.83 L244.14,124.74 L243.21,124.24 L243.03,124.15 L225.46,114.81 L224.35,114.22 L223.24,113.63 L213.73,108.58 L204.22,113.63 L203.11,114.22 L202,114.81 L193.59,119.28 L193.59,119.28 L193.52,119.28 L184.44,124.11 L184.26,124.2 L183.33,124.7 L183.15,124.79 L182.22,125.29 L182.04,125.38 L180.51,126.2 L180.51,129.83 L180.44,129.86 Z"
              id="Shape"
              fill="#FFFFFF"></path>
            <path
              d="M222.69,171.77 L222.69,136 L204.69,136 L204.69,172 L222.69,172 L222.69,171.77 Z M207.77,140.77 C207.77,140.444152 208.034152,140.18 208.36,140.18 L219,140.18 C219.325848,140.18 219.59,140.444152 219.59,140.77 L219.59,162 C219.59,162.325848 219.325848,162.59 219,162.59 L208.36,162.59 C208.034152,162.59 207.77,162.325848 207.77,162 L207.77,140.77 Z"
              id="Shape"
              fill={accentColor}></path>
            <rect
              id="Rectangle-path"
              fill="#E1E5E9"
              x="214.26"
              y="151.94"
              width="4.13"
              height="9.43"></rect>
            <rect
              id="Rectangle-path"
              fill="#E1E5E9"
              x="208.95"
              y="151.94"
              width="4.13"
              height="9.43"></rect>
            <rect
              id="Rectangle-path"
              fill="#E1E5E9"
              x="214.26"
              y="141.33"
              width="4.13"
              height="9.43"></rect>
            <rect
              id="Rectangle-path"
              fill="#E1E5E9"
              x="208.95"
              y="141.33"
              width="4.13"
              height="9.43"></rect>
            <path
              d="M208.36,162.56 L219,162.56 C219.325848,162.56 219.59,162.295848 219.59,161.97 L219.59,140.74 C219.59,140.414152 219.325848,140.15 219,140.15 L208.36,140.15 C208.034152,140.15 207.77,140.414152 207.77,140.74 L207.77,162 C207.78599,162.314076 208.045517,162.560407 208.36,162.56 Z M208.95,151.95 L213.08,151.95 L213.08,161.38 L208.95,161.38 L208.95,151.95 Z M214.26,141.34 L218.39,141.34 L218.39,150.77 L214.26,150.77 L214.26,141.34 Z M218.39,161.34 L214.26,161.34 L214.26,151.91 L218.39,151.91 L218.39,161.34 Z M213.08,150.73 L208.95,150.73 L208.95,141.3 L213.08,141.3 L213.08,150.73 Z"
              id="Shape"
              fill="#4C5A68"></path>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="241.12 169.67 244.92 169.67 244.92 169.19 243.09 169.19 239.14 169.19 237.16 169.19 235.49 169.19 235.49 169.67 237.16 169.67"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="239.14 167.31 243.09 167.31 244.92 167.31 244.92 166.83 244.63 166.83 244.63 167 237.16 167 235.78 167 235.78 166.83 235.49 166.83 235.49 167.31 237.16 167.31"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="239.14 176.75 243.09 176.75 244.92 176.75 244.92 176.27 241.12 176.27 237.16 176.27 235.49 176.27 235.49 176.75 237.16 176.75"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="241.12 174.39 244.92 174.39 244.92 174.36 244.92 173.91 243.09 173.91 239.14 173.91 237.16 173.91 235.49 173.91 235.49 174.36 235.49 174.39 237.16 174.39"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="244.92 180.99 242.96 180.99 242.37 180.99 241.78 180.99 241.12 180.99 237.16 180.99 235.49 180.99 235.49 181.13 235.49 181.47 237.16 181.47 239.14 181.47 241.78 181.47 242.37 181.47 242.96 181.47 243.09 181.47 244.92 181.47 244.92 181.13"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="239.14 172.03 243.09 172.03 244.92 172.03 244.92 171.99 244.92 171.77 244.92 171.55 241.12 171.55 237.16 171.55 235.49 171.55 235.49 171.77 235.49 171.99 235.49 172.03 237.16 172.03"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="241.12 179.11 241.78 179.11 242.37 179.11 242.96 179.11 244.92 179.11 244.92 178.63 243.09 178.63 242.96 178.63 242.37 178.63 241.78 178.63 239.14 178.63 237.16 178.63 235.49 178.63 235.49 179.11 237.16 179.11"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="186.05 181.47 186.64 181.47 187.23 181.47 187.71 181.47 189.69 181.47 191.67 181.47 191.85 181.47 191.85 181.13 191.85 180.99 189.69 180.99 187.23 180.99 186.64 180.99 186.05 180.99 185.74 180.99 182.41 180.99 182.41 181.13 182.41 181.47 183.76 181.47"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="187.71 167.31 189.69 167.31 191.67 167.31 191.85 167.31 191.85 166.83 191.5 166.83 191.5 167 189.69 167 182.66 167 182.66 166.83 182.41 166.83 182.41 167.31 183.76 167.31"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="189.69 169.67 191.85 169.67 191.85 169.19 191.67 169.19 189.69 169.19 187.71 169.19 183.76 169.19 182.41 169.19 182.41 169.67 185.74 169.67"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="186.05 179.11 186.64 179.11 187.23 179.11 189.69 179.11 191.85 179.11 191.85 178.63 191.67 178.63 189.69 178.63 187.71 178.63 187.23 178.63 186.64 178.63 186.05 178.63 183.76 178.63 182.41 178.63 182.41 179.11 185.74 179.11"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="187.71 176.75 189.69 176.75 191.67 176.75 191.85 176.75 191.85 176.27 189.69 176.27 185.74 176.27 182.41 176.27 182.41 176.75 183.76 176.75"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="189.69 174.39 191.85 174.39 191.85 174.36 191.85 173.91 191.67 173.91 189.69 173.91 187.71 173.91 183.76 173.91 182.41 173.91 182.41 174.36 182.41 174.39 185.74 174.39"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="187.71 172.03 189.69 172.03 191.67 172.03 191.85 172.03 191.85 171.99 191.85 171.77 191.85 171.55 189.69 171.55 185.74 171.55 182.41 171.55 182.41 171.77 182.41 171.99 182.41 172.03 183.76 172.03"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="124.99 169.67 125.58 169.67 126.16 169.67 127.24 169.67 129.49 169.67 129.49 169.19 129.22 169.19 127.24 169.19 126.16 169.19 125.58 169.19 125.26 169.19 124.99 169.19 121.3 169.19 120.06 169.19 120.06 169.67 123.28 169.67"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="121.94 172.03 124.99 172.03 125.26 172.03 125.58 172.03 126.16 172.03 127.24 172.03 129.22 172.03 129.49 172.03 129.49 171.99 129.49 171.77 129.49 171.55 127.24 171.55 126.16 171.55 125.58 171.55 124.99 171.55 123.28 171.55 120.06 171.55 120.06 172.03 121.3 172.03"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="121.53 176.75 122.12 176.75 122.71 176.75 125.26 176.75 127.24 176.75 129.22 176.75 129.49 176.75 129.49 176.27 127.24 176.27 123.28 176.27 122.71 176.27 122.12 176.27 121.53 176.27 120.06 176.27 120.06 176.75 121.3 176.75"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="124.99 167.31 125.26 167.31 125.58 167.31 126.16 167.31 127.24 167.31 129.22 167.31 129.49 167.31 129.49 166.83 129.2 166.83 129.2 167 127.24 167 126.16 167 125.58 167 124.99 167 120.35 167 120.35 166.83 120.06 166.83 120.06 167.31 121.3 167.31"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="122.12 179.11 122.71 179.11 123.28 179.11 127.24 179.11 129.49 179.11 129.49 178.63 129.22 178.63 127.24 178.63 125.26 178.63 122.71 178.63 122.12 178.63 121.53 178.63 121.3 178.63 120.06 178.63 120.06 179.11 121.53 179.11"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="123.28 180.99 121.75 180.99 120.06 180.99 120.06 181.47 121.3 181.47 125.26 181.47 127.24 181.47 129.22 181.47 129.49 181.47 129.49 181.13 129.49 180.99 127.24 180.99"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="122.12 174.39 122.71 174.39 123.28 174.39 124.99 174.39 127.24 174.39 129.49 174.39 129.49 174.36 129.49 173.91 129.22 173.91 127.24 173.91 125.58 173.91 125.26 173.91 124.99 173.91 122.71 173.91 122.12 173.91 121.53 173.91 121.3 173.91 120.06 173.91 120.06 174.39 121.53 174.39"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="303.36 169.19 303.27 169.19 302.77 169.19 302.18 169.19 301.29 169.19 299.31 169.19 297.84 169.19 297.84 169.67 301.29 169.67 302.18 169.67 302.77 169.67 303.36 169.67 305.25 169.67 307.28 169.67 307.28 169.19 307.23 169.19"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="303.36 171.55 302.77 171.55 302.18 171.55 301.29 171.55 297.84 171.55 297.84 171.77 297.84 171.99 297.84 172.03 299.31 172.03 301.29 172.03 302.18 172.03 302.77 172.03 303.27 172.03 303.36 172.03 305.39 172.03 307.23 172.03 307.28 172.03 307.28 171.55 305.25 171.55"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="306.99 167 303.36 167 302.77 167 302.18 167 301.29 167 298.14 167 298.14 166.83 297.84 166.83 297.84 167.31 299.31 167.31 301.29 167.31 302.18 167.31 302.77 167.31 303.27 167.31 303.36 167.31 307.23 167.31 307.28 167.31 307.28 166.83 306.99 166.83"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="305.8 178.63 305.21 178.63 304.62 178.63 303.27 178.63 301.29 178.63 299.31 178.63 297.84 178.63 297.84 179.11 301.29 179.11 304.62 179.11 305.21 179.11 305.25 179.11 305.8 179.11 307.28 179.11 307.28 178.63 307.23 178.63"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="305.8 173.91 305.21 173.91 304.62 173.91 303.36 173.91 303.27 173.91 302.77 173.91 301.29 173.91 299.31 173.91 297.84 173.91 297.84 174.36 297.84 174.39 301.29 174.39 303.36 174.39 304.62 174.39 305.21 174.39 305.25 174.39 305.8 174.39 307.28 174.39 307.28 173.91 307.23 173.91"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="305.25 180.99 301.29 180.99 297.84 180.99 297.84 181.13 297.84 181.47 299.31 181.47 301.29 181.47 303.27 181.47 307.23 181.47 307.28 181.47 307.28 180.99 305.59 180.99"></polygon>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="305.25 176.27 305.21 176.27 304.62 176.27 301.29 176.27 297.84 176.27 297.84 176.75 299.31 176.75 301.29 176.75 303.27 176.75 304.62 176.75 305.21 176.75 305.8 176.75 307.23 176.75 307.28 176.75 307.28 176.27 305.8 176.27"></polygon>
            <rect
              id="Rectangle-path"
              fill="#E4E6E8"
              x="246.1"
              y="93.57"
              width="0.1"
              height="2.16"></rect>
            <rect
              id="Rectangle-path"
              fill="#E4E6E8"
              x="181.14"
              y="93.57"
              width="0.1"
              height="2.16"></rect>
            <rect
              id="Rectangle-path"
              fill="#C9CFD4"
              x="182.41"
              y="93.57"
              width="62.51"
              height="2.16"></rect>
            <polygon
              id="Shape"
              fill="#44515F"
              points="181.82 95.72 182.41 95.72 182.41 93.57 181.82 93.57 181.24 93.57 181.24 95.72"></polygon>
            <polygon
              id="Shape"
              fill="#44515F"
              points="245.51 95.72 246.1 95.72 246.1 93.57 245.51 93.57 244.92 93.57 244.92 95.72"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="241.12 170.61 241.12 171.55 244.92 171.55 244.92 170.61 244.92 169.67 241.12 169.67"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="241.12 169.67 237.16 169.67 237.16 170.61 237.16 171.55 241.12 171.55 241.12 170.61"></polygon>
            <rect
              id="Rectangle-path"
              fill="#EDEEF0"
              x="239.14"
              y="167.31"
              width="3.96"
              height="1.88"></rect>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="243.09"
              y="167.31"
              width="1.83"
              height="1.88"></rect>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="239.14 169.19 239.14 167.31 237.16 167.31 235.49 167.31 235.49 169.19 237.16 169.19"></polygon>
            <rect
              id="Rectangle-path"
              fill="#EDEEF0"
              x="237.16"
              y="165.21"
              width="3.96"
              height="0.22"></rect>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="244.63 165.43 244.63 166.83 244.92 166.83 244.92 165.21 241.12 165.21 241.12 165.43"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="242.37 179.11 241.78 179.11 241.12 179.11 241.12 179.95 241.12 180.05 241.12 180.54 241.12 180.99 241.78 180.99 242.37 180.99 242.96 180.99 244.92 180.99 244.92 180.54 244.92 180.05 244.92 179.95 244.92 179.11 242.96 179.11"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="239.14 176.75 239.14 177.3 239.14 177.89 239.14 178.48 239.14 178.63 241.78 178.63 242.37 178.63 242.96 178.63 243.09 178.63 243.09 176.75"></polygon>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="243.09"
              y="176.75"
              width="1.83"
              height="1.88"></rect>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="239.14 178.63 239.14 178.48 239.14 177.89 239.14 177.3 239.14 176.75 237.16 176.75 235.49 176.75 235.49 177.3 235.49 177.89 235.49 178.48 235.49 178.63 237.16 178.63"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="241.12 174.39 237.16 174.39 237.16 174.95 237.16 176.27 241.12 176.27 241.12 174.95"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="241.12 174.95 241.12 176.27 244.92 176.27 244.92 174.95 244.92 174.39 241.12 174.39"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="243.09 172.36 243.09 172.58 243.09 172.95 243.09 173.17 243.09 173.77 243.09 173.91 244.92 173.91 244.92 173.77 244.92 173.17 244.92 172.95 244.92 172.58 244.92 172.36 244.92 172.03 243.09 172.03"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="239.14 173.91 239.14 173.77 239.14 173.17 239.14 172.95 239.14 172.58 239.14 172.36 239.14 172.03 237.16 172.03 235.49 172.03 235.49 172.36 235.49 172.58 235.49 172.95 235.49 173.17 235.49 173.77 235.49 173.91 237.16 173.91"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="243.09 173.17 243.09 172.95 243.09 172.58 243.09 172.36 243.09 172.03 239.14 172.03 239.14 172.36 239.14 172.58 239.14 172.95 239.14 173.17 239.14 173.77 239.14 173.91 243.09 173.91 243.09 173.77"></polygon>
            <rect
              id="Rectangle-path"
              fill="#EDEEF0"
              x="243.09"
              y="181.47"
              width="1.83"
              height="1.14"></rect>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="237.16 181.47 235.49 181.47 235.49 182.61 237.16 182.61 239.14 182.61 239.14 181.47"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="242.96 181.47 242.37 181.47 241.78 181.47 239.14 181.47 239.14 182.61 241.78 182.61 242.37 182.61 242.96 182.61 243.09 182.61 243.09 181.47"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="241.12 180.05 241.12 179.95 241.12 179.11 237.16 179.11 237.16 179.95 237.16 180.05 237.16 180.54 237.16 180.99 241.12 180.99 241.12 180.54"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="235.78 165.43 237.16 165.43 237.16 165.21 235.49 165.21 235.49 166.83 235.78 166.83"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="237.16 174.95 237.16 174.39 235.49 174.39 235.49 174.95 235.49 176.27 237.16 176.27"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="237.16 170.61 237.16 169.67 235.49 169.67 235.49 170.61 235.49 171.55 237.16 171.55"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="237.16 180.54 237.16 180.05 237.16 179.95 237.16 179.11 235.49 179.11 235.49 179.95 235.49 180.05 235.49 180.54 235.49 180.99 237.16 180.99"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="189.69 170.61 189.69 171.55 191.85 171.55 191.85 170.61 191.85 169.67 189.69 169.67"></polygon>
            <rect
              id="Rectangle-path"
              fill="#EDEEF0"
              x="191.67"
              y="167.31"
              width="0.18"
              height="1.88"></rect>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="189.69 167.31 187.71 167.31 187.71 169.19 189.69 169.19 191.67 169.19 191.67 167.31"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="191.5 165.43 191.5 166.83 191.85 166.83 191.85 165.21 189.69 165.21 189.69 165.43"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="189.69 179.95 189.69 180.05 189.69 180.54 189.69 180.99 191.85 180.99 191.85 180.54 191.85 180.05 191.85 179.95 191.85 179.11 189.69 179.11"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="191.67 177.3 191.67 177.89 191.67 178.48 191.67 178.63 191.85 178.63 191.85 178.48 191.85 177.89 191.85 177.3 191.85 176.75 191.67 176.75"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="191.67 177.89 191.67 177.3 191.67 176.75 189.69 176.75 187.71 176.75 187.71 177.3 187.71 177.89 187.71 178.48 187.71 178.63 189.69 178.63 191.67 178.63 191.67 178.48"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="189.69 174.95 189.69 176.27 191.85 176.27 191.85 174.95 191.85 174.39 189.69 174.39"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="191.67 173.17 191.67 172.95 191.67 172.58 191.67 172.36 191.67 172.03 189.69 172.03 187.71 172.03 187.71 172.36 187.71 172.58 187.71 172.95 187.71 173.17 187.71 173.77 187.71 173.91 189.69 173.91 191.67 173.91 191.67 173.77"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="191.67 172.36 191.67 172.58 191.67 172.95 191.67 173.17 191.67 173.77 191.67 173.91 191.85 173.91 191.85 173.77 191.85 173.17 191.85 172.95 191.85 172.58 191.85 172.36 191.85 172.03 191.67 172.03"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="189.69 181.47 187.71 181.47 187.71 182.61 189.69 182.61 191.67 182.61 191.67 181.47"></polygon>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="191.67"
              y="181.47"
              width="0.18"
              height="1.14"></rect>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="189.69 169.67 185.74 169.67 185.74 170.61 185.74 171.55 189.69 171.55 189.69 170.61"></polygon>
            <rect
              id="Rectangle-path"
              fill="#EDEEF0"
              x="183.76"
              y="167.31"
              width="3.96"
              height="1.88"></rect>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="182.41"
              y="167.31"
              width="1.34"
              height="1.88"></rect>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="182.66 165.43 185.74 165.43 185.74 165.21 182.41 165.21 182.41 166.83 182.66 166.83"></polygon>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="185.73"
              y="165.21"
              width="3.96"
              height="0.22"></rect>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="187.71 177.89 187.71 177.3 187.71 176.75 183.76 176.75 183.76 178.63 186.05 178.63 186.64 178.63 187.23 178.63 187.71 178.63 187.71 178.48"></polygon>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="182.41"
              y="176.75"
              width="1.34"
              height="1.88"></rect>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="185.74 174.95 185.74 174.39 182.41 174.39 182.41 174.95 182.41 176.27 185.74 176.27"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="189.69 174.39 185.74 174.39 185.74 174.95 185.74 176.27 189.69 176.27 189.69 174.95"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="183.76 173.77 183.76 173.17 183.76 172.95 183.76 172.58 183.76 172.36 183.76 172.03 182.41 172.03 182.41 172.36 182.41 172.58 182.41 172.95 182.41 173.17 182.41 173.77 182.41 173.91 183.76 173.91"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="187.71 173.17 187.71 172.95 187.71 172.58 187.71 172.36 187.71 172.03 183.76 172.03 183.76 172.36 183.76 172.58 183.76 172.95 183.76 173.17 183.76 173.77 183.76 173.91 187.71 173.91 187.71 173.77"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="185.74 170.61 185.74 169.67 182.41 169.67 182.41 170.61 182.41 171.55 185.74 171.55"></polygon>
            <rect
              id="Rectangle-path"
              fill="#EDEEF0"
              x="182.41"
              y="181.47"
              width="1.34"
              height="1.14"></rect>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="187.71 181.47 187.23 181.47 186.64 181.47 186.05 181.47 183.76 181.47 183.76 182.61 186.05 182.61 186.64 182.61 187.23 182.61 187.71 182.61"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="189.69 180.05 189.69 179.95 189.69 179.11 187.23 179.11 186.64 179.11 186.05 179.11 185.74 179.11 185.74 179.95 185.74 180.05 185.74 180.54 185.74 180.99 186.05 180.99 186.64 180.99 187.23 180.99 189.69 180.99 189.69 180.54"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="185.74 180.54 185.74 180.05 185.74 179.95 185.74 179.11 182.41 179.11 182.41 179.95 182.41 180.05 182.41 180.54 182.41 180.99 185.74 180.99"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="127.24 170.61 127.24 171.55 129.49 171.55 129.49 170.61 129.49 169.67 127.24 169.67"></polygon>
            <rect
              id="Rectangle-path"
              fill="#EDEEF0"
              x="129.21"
              y="167.31"
              width="0.28"
              height="1.88"></rect>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="127.24 167.31 126.16 167.31 125.58 167.31 125.26 167.31 125.26 169.19 125.58 169.19 126.16 169.19 127.24 169.19 129.22 169.19 129.22 167.31"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="129.2 165.43 129.2 166.83 129.49 166.83 129.49 165.21 127.24 165.21 127.24 165.43"></polygon>
            <rect
              id="Rectangle-path"
              fill="#EDEEF0"
              x="129.21"
              y="176.75"
              width="0.28"
              height="1.88"></rect>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="127.24 176.75 125.26 176.75 125.26 178.63 127.24 178.63 129.22 178.63 129.22 176.75"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="127.24 174.95 127.24 176.27 129.49 176.27 129.49 174.95 129.49 174.39 127.24 174.39"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="129.22 173.17 129.22 172.95 129.22 172.58 129.22 172.36 129.22 172.03 127.24 172.03 126.16 172.03 125.58 172.03 125.26 172.03 125.26 172.58 125.26 172.85 125.26 173.17 125.26 173.91 125.58 173.91 127.24 173.91 129.22 173.91 129.22 173.77"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="129.22 172.36 129.22 172.58 129.22 172.95 129.22 173.17 129.22 173.77 129.22 173.91 129.49 173.91 129.49 173.77 129.49 173.17 129.49 172.95 129.49 172.58 129.49 172.36 129.49 172.03 129.22 172.03"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="127.24 181.47 125.26 181.47 125.26 182.61 127.24 182.61 129.22 182.61 129.22 181.47"></polygon>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="129.21"
              y="181.47"
              width="0.28"
              height="1.14"></rect>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="129.49 180.05 129.49 179.95 129.49 179.11 127.24 179.11 127.24 179.95 127.24 180.05 127.24 180.54 127.24 180.99 129.49 180.99 129.49 180.54"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="127.24 169.67 126.16 169.67 125.58 169.67 124.99 169.67 123.28 169.67 123.28 170.61 123.28 171.55 124.99 171.55 125.58 171.55 126.16 171.55 127.24 171.55 127.24 170.61"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="124.99 167.31 121.3 167.31 121.3 169.19 124.99 169.19 125.26 169.19 125.26 167.31"></polygon>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="120.06"
              y="167.31"
              width="1.25"
              height="1.88"></rect>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="120.35 165.43 123.28 165.43 123.28 165.21 120.06 165.21 120.06 166.83 120.35 166.83"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="124.99 165.43 125.58 165.43 126.16 165.43 127.24 165.43 127.24 165.21 126.16 165.21 125.58 165.21 124.99 165.21 123.28 165.21 123.28 165.43"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="123.28 179.95 123.28 180.05 123.28 180.54 123.28 180.99 127.24 180.99 127.24 180.54 127.24 180.05 127.24 179.95 127.24 179.11 123.28 179.11"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="122.71 176.75 122.12 176.75 121.53 176.75 121.3 176.75 121.3 178.63 121.53 178.63 122.12 178.63 122.71 178.63 125.26 178.63 125.26 176.75"></polygon>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="120.06"
              y="176.75"
              width="1.25"
              height="1.88"></rect>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="122.12 176.27 122.71 176.27 123.28 176.27 123.28 174.39 122.71 174.39 122.12 174.39 121.53 174.39 120.06 174.39 120.06 176.27 121.53 176.27"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="127.24 174.39 124.99 174.39 123.28 174.39 123.28 176.27 127.24 176.27 127.24 174.95"></polygon>
            <rect
              id="Rectangle-path"
              fill="#EDEEF0"
              x="120.06"
              y="172.03"
              width="1.25"
              height="1.88"></rect>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="125.26 172.85 125.26 172.58 125.26 172.03 124.99 172.03 121.94 172.03 121.3 172.03 121.3 173.91 121.53 173.91 122.12 173.91 122.71 173.91 124.99 173.91 125.26 173.91 125.26 173.17"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="123.28 170.61 123.28 169.67 120.06 169.67 120.06 170.61 120.06 171.55 123.28 171.55"></polygon>
            <rect
              id="Rectangle-path"
              fill="#EDEEF0"
              x="120.06"
              y="181.47"
              width="1.25"
              height="1.14"></rect>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="121.3"
              y="181.47"
              width="3.96"
              height="1.14"></rect>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="123.28 180.99 123.28 180.54 123.28 180.05 123.28 179.95 123.28 179.11 122.71 179.11 122.12 179.11 121.53 179.11 120.06 179.11 120.06 180.05 120.06 180.99 121.75 180.99"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="305.25 170.61 305.25 171.55 307.28 171.55 307.28 170.61 307.28 169.67 305.25 169.67"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="303.36 169.19 307.23 169.19 307.23 167.31 303.36 167.31 303.27 167.31 303.27 169.19"></polygon>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="307.23"
              y="167.31"
              width="0.1"
              height="1.88"></rect>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="302.18 165.43 302.77 165.43 303.36 165.43 305.25 165.43 305.25 165.21 303.36 165.21 302.77 165.21 302.18 165.21 301.29 165.21 301.29 165.43"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="305.25 165.43 306.99 165.43 306.99 166.83 307.28 166.83 307.28 165.21 305.25 165.21"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="305.25 179.11 305.25 180.05 305.25 180.99 305.59 180.99 307.28 180.99 307.28 180.05 307.28 179.11 305.8 179.11"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="301.29 180.05 301.29 180.54 301.29 180.99 305.25 180.99 305.25 180.05 305.25 179.11 305.21 179.11 304.62 179.11 301.29 179.11 301.29 179.95"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="304.62 178.63 305.21 178.63 305.8 178.63 307.23 178.63 307.23 176.75 305.8 176.75 305.21 176.75 304.62 176.75 303.27 176.75 303.27 178.63"></polygon>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="307.23"
              y="176.75"
              width="0.1"
              height="1.88"></rect>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="301.29 176.27 304.62 176.27 305.21 176.27 305.25 176.27 305.25 174.39 305.21 174.39 304.62 174.39 303.36 174.39 301.29 174.39 301.29 174.95"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="305.25 174.39 305.25 176.27 305.8 176.27 307.28 176.27 307.28 174.39 305.8 174.39"></polygon>
            <rect
              id="Rectangle-path"
              fill="#EDEEF0"
              x="307.23"
              y="172.03"
              width="0.1"
              height="1.88"></rect>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="303.27 172.66 303.27 173.17 303.27 173.91 303.36 173.91 304.62 173.91 305.21 173.91 305.8 173.91 307.23 173.91 307.23 172.03 305.39 172.03 303.36 172.03 303.27 172.03 303.27 172.58"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="301.29 171.55 302.18 171.55 302.77 171.55 303.36 171.55 305.25 171.55 305.25 170.61 305.25 169.67 303.36 169.67 302.77 169.67 302.18 169.67 301.29 169.67 301.29 170.61"></polygon>
            <rect
              id="Rectangle-path"
              fill="#EDEEF0"
              x="307.23"
              y="181.47"
              width="0.1"
              height="1.14"></rect>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="301.29 181.47 299.31 181.47 299.31 182.61 301.29 182.61 303.27 182.61 303.27 181.47"></polygon>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="303.27"
              y="181.47"
              width="3.96"
              height="1.14"></rect>
            <rect
              id="Rectangle-path"
              fill="#EDEEF0"
              x="297.84"
              y="167.31"
              width="1.47"
              height="1.88"></rect>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="301.29 169.19 302.18 169.19 302.77 169.19 303.27 169.19 303.27 167.31 302.77 167.31 302.18 167.31 301.29 167.31 299.31 167.31 299.31 169.19"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="298.14 165.43 301.29 165.43 301.29 165.21 297.84 165.21 297.84 166.83 298.14 166.83"></polygon>
            <rect
              id="Rectangle-path"
              fill="#EDEEF0"
              x="297.84"
              y="176.75"
              width="1.47"
              height="1.88"></rect>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="301.29 178.63 303.27 178.63 303.27 176.75 301.29 176.75 299.31 176.75 299.31 178.63"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="301.29 174.95 301.29 174.39 297.84 174.39 297.84 174.95 297.84 176.27 301.29 176.27"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="299.31 172.58 299.31 172.95 299.31 173.17 299.31 173.77 299.31 173.91 301.29 173.91 302.77 173.91 303.27 173.91 303.27 173.17 303.27 172.66 303.27 172.58 303.27 172.03 302.77 172.03 302.18 172.03 301.29 172.03 299.31 172.03 299.31 172.36"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="299.31 173.77 299.31 173.17 299.31 172.95 299.31 172.58 299.31 172.36 299.31 172.03 297.84 172.03 297.84 172.36 297.84 172.58 297.84 172.95 297.84 173.17 297.84 173.77 297.84 173.91 299.31 173.91"></polygon>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="301.29 170.61 301.29 169.67 297.84 169.67 297.84 170.61 297.84 171.55 301.29 171.55"></polygon>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="297.84"
              y="181.47"
              width="1.47"
              height="1.14"></rect>
            <polygon
              id="Shape"
              fill="#EDEEF0"
              points="301.29 180.54 301.29 180.05 301.29 179.95 301.29 179.11 297.84 179.11 297.84 179.95 297.84 180.05 297.84 180.54 297.84 180.99 301.29 180.99"></polygon>
            <path
              d="M179.76,83.69 L180.21,83.69 L180.21,92.39 L247.57,92.39 L247.57,75 L241.57,75 L241.57,92.26 L240.39,92.26 L240.39,75 L234.91,75 L234.91,92.26 L233.73,92.26 L233.73,75 L228.25,75 L228.25,92.26 L227.07,92.26 L227.07,75 L221.59,75 L221.59,92.26 L220.4,92.26 L220.4,75 L214.92,75 L214.92,92.26 L213.74,92.26 L213.74,75 L208.26,75 L208.26,92.26 L207.08,92.26 L207.08,75 L201.6,75 L201.6,92.26 L200.42,92.26 L200.42,75 L195,75 L195,92.26 L193.82,92.26 L193.82,75 L179.82,75 L179.82,83.7 L179.76,83.69 Z M187.12,82.27 L187.12,75 L188.3,75 L188.3,92.26 L187.12,92.26 L187.12,82.26 L187.12,82.27 Z"
              id="Shape"
              fill="#FFFFFF"></path>
            <rect
              id="Rectangle-path"
              fill="#C5C9D1"
              x="139.96"
              y="138.68"
              width="9.52"
              height="22.7"></rect>
            <rect
              id="Rectangle-path"
              fill="#C5C9D1"
              x="163.12"
              y="138.68"
              width="10.15"
              height="22.7"></rect>
            <path
              d="M150.07,162.56 L176.52,162.56 L176.52,161.38 L174.46,161.38 L174.46,138.09 C174.46,137.933522 174.397839,137.783453 174.287193,137.672807 C174.176547,137.562161 174.026478,137.5 173.87,137.5 L139.37,137.5 C139.213522,137.5 139.063453,137.562161 138.952807,137.672807 C138.842161,137.783453 138.78,137.933522 138.78,138.09 L138.78,161.38 L136.72,161.38 L136.72,162.56 L150.07,162.56 L150.07,162.56 Z M140,138.68 L149.52,138.68 L149.52,161.38 L140,161.38 L140,138.68 Z M173.32,138.68 L173.32,161.38 L163.12,161.38 L163.12,138.68 L173.32,138.68 Z M150.7,161.38 L150.7,138.68 L161.98,138.68 L161.98,161.38 L150.7,161.38 Z"
              id="Shape"
              fill="#4C5A68"></path>
            <rect
              id="Rectangle-path"
              fill="#E1E5E9"
              x="150.66"
              y="138.68"
              width="11.28"
              height="22.7"></rect>
            <rect
              id="Rectangle-path"
              fill="#C5C9D1"
              x="254.8"
              y="138.68"
              width="9.52"
              height="22.7"></rect>
            <rect
              id="Rectangle-path"
              fill="#C5C9D1"
              x="277.96"
              y="138.68"
              width="10.15"
              height="22.7"></rect>
            <path
              d="M264.91,162.56 L291.36,162.56 L291.36,161.38 L289.3,161.38 L289.3,138.09 C289.3,137.933522 289.237839,137.783453 289.127193,137.672807 C289.016547,137.562161 288.866478,137.5 288.71,137.5 L254.21,137.5 C254.053522,137.5 253.903453,137.562161 253.792807,137.672807 C253.682161,137.783453 253.62,137.933522 253.62,138.09 L253.62,161.38 L251.56,161.38 L251.56,162.56 L264.91,162.56 L264.91,162.56 Z M254.8,138.68 L264.32,138.68 L264.32,161.38 L254.8,161.38 L254.8,138.68 Z M288.12,161.38 L278,161.38 L278,138.68 L288.15,138.68 L288.12,161.38 Z M265.5,138.68 L276.78,138.68 L276.78,161.38 L265.5,161.38 L265.5,138.68 Z"
              id="Shape"
              fill="#4C5A68"></path>
            <rect
              id="Rectangle-path"
              fill="#E1E5E9"
              x="265.5"
              y="138.68"
              width="11.28"
              height="22.7"></rect>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="126.16 166.83 125.58 166.83 124.99 166.83 123.28 166.83 120.35 166.83 120.35 167 124.99 167 125.58 167 126.16 167 127.24 167 129.2 167 129.2 166.83 127.24 166.83"></polygon>
            <rect
              id="Rectangle-path"
              fill="#CCCFD4"
              x="127.24"
              y="165.43"
              width="1.96"
              height="1.4"></rect>
            <rect
              id="Rectangle-path"
              fill="#CCCFD4"
              x="120.35"
              y="165.43"
              width="2.93"
              height="1.4"></rect>
            <polygon
              id="Shape"
              fill="#BCC1C6"
              points="124.99 166.83 125.58 166.83 126.16 166.83 127.24 166.83 127.24 165.43 126.16 165.43 125.58 165.43 124.99 165.43 123.28 165.43 123.28 166.83"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="185.74 166.83 182.66 166.83 182.66 167 189.69 167 191.5 167 191.5 166.83 189.69 166.83"></polygon>
            <rect
              id="Rectangle-path"
              fill="#CCCFD4"
              x="189.69"
              y="165.43"
              width="1.81"
              height="1.4"></rect>
            <rect
              id="Rectangle-path"
              fill="#CCCFD4"
              x="182.66"
              y="165.43"
              width="3.08"
              height="1.4"></rect>
            <rect
              id="Rectangle-path"
              fill="#BCC1C6"
              x="185.73"
              y="165.43"
              width="3.96"
              height="1.4"></rect>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="237.16 166.83 235.78 166.83 235.78 167 237.16 167 244.63 167 244.63 166.83 241.12 166.83"></polygon>
            <rect
              id="Rectangle-path"
              fill="#CCCFD4"
              x="237.16"
              y="165.43"
              width="3.96"
              height="1.4"></rect>
            <rect
              id="Rectangle-path"
              fill="#BCC1C6"
              x="241.12"
              y="165.43"
              width="3.51"
              height="1.4"></rect>
            <rect
              id="Rectangle-path"
              fill="#BCC1C6"
              x="235.78"
              y="165.43"
              width="1.38"
              height="1.4"></rect>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="303.36 166.83 302.77 166.83 302.18 166.83 301.29 166.83 298.14 166.83 298.14 167 301.29 167 302.18 167 302.77 167 303.36 167 306.99 167 306.99 166.83 305.25 166.83"></polygon>
            <polygon
              id="Shape"
              fill="#CCCFD4"
              points="302.77 165.43 302.18 165.43 301.29 165.43 301.29 166.83 302.18 166.83 302.77 166.83 303.36 166.83 305.25 166.83 305.25 165.43 303.36 165.43"></polygon>
            <rect
              id="Rectangle-path"
              fill="#BCC1C6"
              x="305.25"
              y="165.43"
              width="1.74"
              height="1.4"></rect>
            <rect
              id="Rectangle-path"
              fill="#BCC1C6"
              x="298.14"
              y="165.43"
              width="3.16"
              height="1.4"></rect>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="273.6 70.52 275.69 70.52 275.69 70.04 275.58 70.04 271.62 70.04 269.64 70.04 269.51 70.04 269.51 70.52 269.64 70.52"></polygon>
            <rect
              id="Rectangle-path"
              fill="#CCCFD4"
              x="269.65"
              y="70.52"
              width="3.96"
              height="1.58"></rect>
            <rect
              id="Rectangle-path"
              fill="#BCC1C6"
              x="273.6"
              y="70.52"
              width="2.09"
              height="1.58"></rect>
            <rect
              id="Rectangle-path"
              fill="#CCCFD4"
              x="275.58"
              y="69.95"
              width="0.11"
              height="0.1"></rect>
            <polygon
              id="Shape"
              fill="#CCCFD4"
              points="271.62 70.04 271.62 69.95 269.64 69.95 269.51 69.95 269.51 70.04 269.64 70.04"></polygon>
            <rect
              id="Rectangle-path"
              fill="#BCC1C6"
              x="271.62"
              y="69.95"
              width="3.96"
              height="0.1"></rect>
            <rect
              id="Rectangle-path"
              fill="#BCC1C6"
              x="269.51"
              y="70.52"
              width="0.13"
              height="1.58"></rect>
            <path
              d="M213.67,54 C213.861039,53.9992924 214.039911,53.9061299 214.15,53.75 C214.88,52.72 232,27.84 232,18 C231.767459,8.04613602 223.63158,0.0981062952 213.675,0.0981062952 C203.71842,0.0981062952 195.582541,8.04613602 195.35,18 C195.35,27.87 212.46,52.75 213.19,53.81 C213.312332,53.9436851 213.489312,54.0137396 213.67,54 L213.67,54 Z M230.81,18 C230.81,26.6 216.5,48.22 213.66,52.42 C210.82,48.21 196.51,26.6 196.51,18 C196.734803,8.6923595 204.344645,1.2640954 213.655,1.2640954 C222.965355,1.2640954 230.575197,8.6923595 230.8,18 L230.81,18 Z"
              id="Shape"
              fill={accentColor}></path>
            <path
              d="M279.94,46.39 C298.89,46.39 333.89,46.28 338.78,46.23 C338.43,39.68 332.24,34.06 325.21,34.06 C324.497156,34.0640671 323.785452,34.1175284 323.08,34.22 C322.808948,34.261054 322.546167,34.1067227 322.45,33.85 C321.543257,31.4527774 319.252949,29.8622861 316.69,29.85 C314.714264,29.8336429 312.85217,30.7721384 311.69,32.37 C311.595761,32.4954821 311.455415,32.5782506 311.3,32.6 C311.14459,32.6223135 310.986626,32.5828223 310.86,32.49 C307.805866,30.2124338 303.896427,29.4124999 300.193156,30.3073925 C296.489886,31.2022851 293.377112,33.6991315 291.7,37.12 C291.585301,37.3505285 291.334352,37.4800504 291.08,37.44 C290.060749,37.2833561 289.031213,37.2031325 288,37.2 C280.75,37.2 274.39,41.69 274.39,46.81 L274.39,47 L279.39,47 C279.378477,46.6814873 279.621998,46.4113998 279.94,46.39 Z"
              id="Shape"
              fill="#FFFFFF"></path>
            <path
              d="M273.77,47.57 L273.77,47.57 C274.091936,47.5645427 274.350046,47.3019824 274.35,46.98 L274.35,46.98 L274.35,46.82 C274.35,41.7 280.71,37.21 287.96,37.21 C289.024854,37.2113764 290.088013,37.2949581 291.14,37.46 C291.394352,37.5000504 291.645301,37.3705285 291.76,37.14 C293.437112,33.7191315 296.549886,31.2222851 300.253156,30.3273925 C303.956427,29.4324999 307.865866,30.2324338 310.92,32.51 C311.046626,32.6028223 311.20459,32.6423135 311.36,32.62 C311.515415,32.5982506 311.655761,32.5154821 311.75,32.39 C312.91217,30.7921384 314.774264,29.8536429 316.75,29.87 C319.312949,29.8822861 321.603257,31.4727774 322.51,33.87 C322.602513,34.1306943 322.866252,34.2897751 323.14,34.25 C323.845452,34.1475284 324.557156,34.0940671 325.27,34.09 C332.27,34.09 338.49,39.71 338.84,46.26 C333.95,46.26 298.95,46.38 280,46.42 C279.674152,46.42 279.41,46.684152 279.41,47.01 L279.41,47.01 C279.41,47.335848 279.674152,47.6 280,47.6 L280,47.6 L309.72,47.54 L330.15,47.48 L336.88,47.48 C340.02,47.48 340.02,47.48 340.02,46.87 C340.02,39.45 333.12,32.95 325.26,32.95 C324.644841,32.9538019 324.030442,32.9938714 323.42,33.07 C322.226439,30.4504283 319.618637,28.7639457 316.74,28.75 C314.610449,28.7444025 312.585524,29.672798 311.2,31.29 C307.910173,29.0441392 303.819427,28.3059968 299.952135,29.2604124 C296.084843,30.2148279 292.807212,32.7714246 290.94,36.29 C289.967763,36.126381 288.985468,36.029488 288,36 C280.12,36 273.21,41 273.21,46.79 L273.21,47 C273.220014,47.3067268 273.463498,47.5545588 273.77,47.57 Z"
              id="Shape"
              fill="#C5C9D1"></path>
            <path
              d="M395.66,64.73 L398.45,65.1 C397.690674,64.4015189 396.575137,64.2535804 395.66,64.73 L395.66,64.73 Z"
              id="Shape"
              fill="#FFFFFF"></path>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="394.05 64.51 394 64.51 394 64.51"></polygon>
            <path
              d="M389.58,63.92 L392.37,64.29 C391.610674,63.5915189 390.495137,63.4435804 389.58,63.92 L389.58,63.92 Z"
              id="Shape"
              fill="#FFFFFF"></path>
            <path
              d="M397.27,63.31 C396.306623,63.1761916 395.329927,63.4356827 394.56,64.03 C394.371142,64.1760317 394.196984,64.3401426 394.04,64.52 L394.04,64.52 L394.04,64.52 C393.538368,63.5057092 392.595787,62.7804798 391.48681,62.5555551 C390.377833,62.3306303 389.227176,62.6313053 388.37,63.37 L388.76,63.82 L388.76,63.82 L389.15,64.27 C389.928855,63.5972237 391.042306,63.4754162 391.948198,63.9638872 C392.85409,64.4523582 393.364141,65.4495835 393.23,66.47 L393.23,66.55 C393.232263,66.8432011 393.449497,67.0902515 393.74,67.13 L393.82,67.13 C394.113201,67.1277371 394.360251,66.9105031 394.4,66.62 C394.543233,65.6024939 395.296779,64.777469 396.297176,64.5428626 C397.297573,64.3082562 398.339341,64.7122563 398.92,65.56 L399.41,65.23 L399.41,65.23 L399.9,64.9 C399.298142,64.0107835 398.337052,63.4297444 397.27,63.31 Z"
              id="Shape"
              fill="#C5C9D1"></path>
            <path
              d="M405,75.34 C404.554157,75.1084697 404.048511,75.0178022 403.55,75.08 L406,76.39 C405.77973,75.9474795 405.431256,75.5815812 405,75.34 L405,75.34 Z"
              id="Shape"
              fill="#FFFFFF"></path>
            <path
              d="M407.52,77.18 L407.46,77.18 C407.46,77.18 407.46,77.18 407.46,77.24 L407.52,77.18 Z"
              id="Shape"
              fill="#FFFFFF"></path>
            <path
              d="M410.41,78.2 C409.961664,77.9652149 409.451825,77.8744216 408.95,77.94 L411.44,79.25 C411.210744,78.8038973 410.851612,78.437792 410.41,78.2 L410.41,78.2 Z"
              id="Shape"
              fill="#FFFFFF"></path>
            <path
              d="M403.53,75.08 C404.028511,75.0178022 404.534157,75.1084697 404.98,75.34 C405.411256,75.5815812 405.75973,75.9474795 405.98,76.39 C406.04871,76.5213562 406.105601,76.6585634 406.15,76.8 C406.347253,77.4275041 406.286066,78.107768 405.98,78.69 C405.809652,78.8693159 405.769228,79.1358479 405.878746,79.3576101 C405.988263,79.5793722 406.224474,79.7092879 406.470406,79.6830232 C406.716338,79.6567585 406.919785,79.479889 406.98,79.24 C407.465848,78.3331587 408.459376,77.8184825 409.480392,77.9447252 C410.501407,78.0709679 411.339658,78.812133 411.59,79.81 L412.73,79.53 C412.457631,78.432011 411.692828,77.5216803 410.658258,77.0640446 C409.623688,76.6064089 408.435638,76.6529065 407.44,77.19 L407.39,77.19 C407.39,77.19 407.39,77.19 407.39,77.13 C407.259574,76.0101337 406.620306,75.0128732 405.657176,74.4267904 C404.694047,73.8407075 403.514554,73.7312165 402.46,74.13 L402.88,75.23 C403.088887,75.1508374 403.307547,75.1003773 403.53,75.08 L403.53,75.08 Z"
              id="Shape"
              fill="#C5C9D1"></path>
            <polygon
              id="Shape"
              fill="#4B5766"
              points="366.6 161.9 365.89 161.32 365.89 161.32"></polygon>
            <rect
              id="Rectangle-path"
              fill="#4B5766"
              x="361.56"
              y="178.36"
              width="0.0"
              height="2.51"></rect>
            <polygon
              id="Shape"
              fill="#E1E5E9"
              points="367.21 179.69 367.21 163.91 367.07 163.79 365.89 162.84 364.98 162.1 363.64 163.18 362.74 163.91 362.74 178.36 362.74 179.69 362.74 179.69"></polygon>
            <path
              d="M366.6,161.9 L365.89,161.33 L365.89,161.33 L364.98,160.6 L363.27,162 L361.56,163.38 L361.56,163.38 L361.56,178.38 L361.56,178.38 L361.56,180.89 L368.39,180.89 L368.39,163.34 L366.87,162.12 L366.6,161.9 Z M362.74,178.37 L362.74,163.91 L363.64,163.18 L365,162.1 L365.91,162.83 L367.09,163.83 L367.24,163.95 L367.24,179.73 L362.77,179.73 L362.74,178.37 Z"
              id="Shape"
              fill="#566373"></path>
            <polygon
              id="Shape"
              fill="#DDE0E3"
              points="377.65 163.09 375.46 161.32 375.46 161.32 376.43 162.11"></polygon>
            <polygon
              id="Shape"
              fill="#4B5766"
              points="376.25 161.97 376.43 162.11 375.46 161.32 375.46 161.32"></polygon>
            <rect
              id="Rectangle-path"
              fill="#4B5766"
              x="371.13"
              y="178.36"
              width="0.0"
              height="2.51"></rect>
            <polygon
              id="Shape"
              fill="#E1E5E9"
              points="376.78 179.69 376.78 163.91 376.63 163.79 375.46 162.84 374.54 162.1 373.21 163.18 372.31 163.91 372.31 178.36 372.31 179.69 372.31 179.69"></polygon>
            <path
              d="M376.43,162.11 L376.25,161.97 L375.45,161.33 L375.45,161.33 L374.54,160.6 L372,162.67 L371.16,163.35 L371.16,163.35 L371.16,178.35 L371.16,178.35 L371.16,180.86 L378,180.86 L378,163.34 L377.69,163.09 L376.43,162.11 Z M372.31,178.37 L372.31,163.91 L373.21,163.18 L374.55,162.1 L375.46,162.83 L376.64,163.83 L376.79,163.95 L376.79,179.73 L372.31,179.73 L372.31,178.37 Z"
              id="Shape"
              fill="#566373"></path>
            <polygon
              id="Shape"
              fill="#DDE0E3"
              points="385.91 162.04 386.99 162.91 385.02 161.32 385.02 161.32 385.58 161.78"></polygon>
            <polygon
              id="Shape"
              fill="#4B5766"
              points="385.58 161.78 385.02 161.32 385.02 161.32 385.53 161.74"></polygon>
            <rect
              id="Rectangle-path"
              fill="#4B5766"
              x="380.69"
              y="178.36"
              width="0.0"
              height="2.51"></rect>
            <polygon
              id="Shape"
              fill="#E1E5E9"
              points="385.02 162.84 384.11 162.1 382.52 163.39 381.87 163.91 381.87 178.36 381.87 179.69 381.87 179.69 386.35 179.69 386.35 163.91 386.2 163.79"></polygon>
            <path
              d="M385.91,162 L385.58,161.74 L385.53,161.74 L385.02,161.33 L384.11,160.6 L381.25,162.9 L380.69,163.35 L380.69,163.35 L380.69,178.35 L380.69,178.35 L380.69,180.86 L387.52,180.86 L387.52,163.34 L386.98,162.91 L385.91,162 Z M386.35,179.65 L381.88,179.65 L381.88,163.91 L382.52,163.39 L384.11,162.11 L385.02,162.84 L386.2,163.84 L386.35,163.96 L386.35,179.65 Z"
              id="Shape"
              fill="#566373"></path>
            <path
              d="M318.1,161.32 L319,162.04 L318.1,161.32 L318.1,161.32 L317.19,160.59 L315.48,162 L313.77,163.38 L313.77,163.38 L313.77,178.38 L313.77,178.38 L313.77,180.89 L320.6,180.89 L320.6,163.34 L320.6,163.34 L319.18,162.19 L318.1,161.32 Z M314.95,178.32 L314.95,163.91 L316.24,162.91 L317.24,162.14 L318.15,162.87 L319.33,163.87 L319.48,163.99 L319.48,179.77 L315,179.77 L314.95,178.32 Z"
              id="Shape"
              fill="#566373"></path>
            <rect
              id="Rectangle-path"
              fill="#4B5766"
              x="313.77"
              y="178.36"
              width="0.0"
              height="2.51"></rect>
            <polygon
              id="Shape"
              fill="#4B5766"
              points="319 162.04 318.1 161.32 318.1 161.32"></polygon>
            <polygon
              id="Shape"
              fill="#E1E5E9"
              points="319.43 179.69 319.43 163.91 319.28 163.79 318.1 162.84 317.19 162.1 316.24 162.87 314.95 163.91 314.95 178.36 314.95 179.69 314.95 179.69"></polygon>
            <polygon
              id="Shape"
              fill="#DDE0E3"
              points="328.5 162 328.75 162.2 329.95 163.16 327.67 161.32 327.67 161.32 327.67 161.32"></polygon>
            <polygon
              id="Shape"
              fill="#4B5766"
              points="327.67 161.32 328.5 162 327.67 161.32"></polygon>
            <rect
              id="Rectangle-path"
              fill="#4B5766"
              x="323.34"
              y="178.36"
              width="0.0"
              height="2.51"></rect>
            <polygon
              id="Shape"
              fill="#E1E5E9"
              points="328.99 179.69 328.99 163.91 328.85 163.79 327.67 162.84 326.76 162.1 325.42 163.18 324.52 163.91 324.52 178.36 324.52 179.69 324.52 179.69"></polygon>
            <path
              d="M328.75,162.2 L328.5,162 L327.67,161.33 L327.67,161.33 L326.76,160.6 L325,162 L323.29,163.38 L323.29,163.38 L323.29,178.38 L323.29,178.38 L323.29,180.89 L330.12,180.89 L330.12,163.34 L330.12,163.34 L329.89,163.16 L328.75,162.2 Z M324.52,178.37 L324.52,163.91 L325.42,163.18 L326.76,162.1 L327.67,162.83 L328.85,163.83 L329,163.95 L329,179.73 L324.53,179.73 L324.52,178.37 Z"
              id="Shape"
              fill="#566373"></path>
            <polygon
              id="Shape"
              fill="#DDE0E3"
              points="338.24 162.13 339.21 162.91 337.24 161.32 337.24 161.32 338.03 161.97"></polygon>
            <polygon
              id="Shape"
              fill="#4B5766"
              points="338.03 161.97 337.24 161.32 337.24 161.32"></polygon>
            <rect
              id="Rectangle-path"
              fill="#4B5766"
              x="332.91"
              y="178.36"
              width="0.0"
              height="2.51"></rect>
            <polygon
              id="Shape"
              fill="#E1E5E9"
              points="338.56 179.69 338.56 163.91 338.41 163.79 337.24 162.84 336.32 162.1 334.99 163.18 334.09 163.91 334.09 178.36 334.09 179.69 334.09 179.69"></polygon>
            <path
              d="M338.24,162.13 L338,162 L337.2,161.36 L337.2,161.36 L336.29,160.63 L334.62,162 L332.91,163.38 L332.91,163.38 L332.91,178.38 L332.91,178.38 L332.91,180.89 L339.74,180.89 L339.74,163.34 L339.2,162.91 L338.24,162.13 Z M334.09,178.36 L334.09,163.91 L334.99,163.18 L336.33,162.1 L337.24,162.83 L338.42,163.83 L338.57,163.95 L338.57,179.73 L334.09,179.73 L334.09,178.36 Z"
              id="Shape"
              fill="#566373"></path>
            <polygon
              id="Shape"
              fill="#DDE0E3"
              points="349.08 163.16 348.84 162.96 348.84 162.96"></polygon>
            <polygon
              id="Shape"
              fill="#DDE0E3"
              points="347.6 161.97 347.66 162.01 347.66 162.01 346.8 161.32 346.8 161.32 347.46 161.85"></polygon>
            <polygon
              id="Shape"
              fill="#ABB0BA"
              points="348.84 162.96 348.84 162.96 347.66 162.01 347.66 162.01"></polygon>
            <polygon
              id="Shape"
              fill="#4B5766"
              points="347.46 161.85 346.8 161.32 346.8 161.32"></polygon>
            <rect
              id="Rectangle-path"
              fill="#4B5766"
              x="342.47"
              y="178.36"
              width="0.0"
              height="2.51"></rect>
            <polygon
              id="Shape"
              fill="#E1E5E9"
              points="347.66 179.69 348.13 179.69 348.13 163.91 347.98 163.79 347.66 163.53 346.8 162.84 345.89 162.1 344.56 163.18 343.65 163.91 343.65 178.36 343.65 179.69 343.65 179.69"></polygon>
            <path
              d="M348.84,163 L347.66,162 L347.6,162 L347.46,161.89 L346.8,161.36 L346.8,161.36 L345.89,160.63 L343.31,162.71 L342.47,163.39 L342.47,163.39 L342.47,178.39 L342.47,178.39 L342.47,180.9 L349.3,180.9 L349.3,163.34 L349.08,163.16 L348.84,163 Z M343.66,178.4 L343.66,163.91 L344.56,163.18 L345.9,162.1 L346.81,162.83 L347.66,163.52 L347.99,163.78 L348.14,163.9 L348.14,179.68 L343.67,179.68 L343.66,178.4 Z"
              id="Shape"
              fill="#566373"></path>
            <polygon
              id="Shape"
              fill="#DDE0E3"
              points="357.24 162.28 358.43 163.24 356.06 161.32 356.06 161.32 356.86 161.97"></polygon>
            <polygon
              id="Shape"
              fill="#4B5766"
              points="356.86 161.97 356.06 161.32 356.06 161.32"></polygon>
            <rect
              id="Rectangle-path"
              fill="#4B5766"
              x="358.56"
              y="163.34"
              width="0.0"
              height="17.53"></rect>
            <polygon
              id="Shape"
              fill="#E1E5E9"
              points="357.24 163.79 356.63 163.3 356.06 162.84 355.15 162.1 352.91 163.91 352.91 178.36 352.91 179.54 352.91 179.69 357.38 179.69 357.38 179.69 357.38 163.91 357.38 163.9"></polygon>
            <path
              d="M358.56,163.34 L358.43,163.23 L357.24,162.23 L356.85,161.92 L356.05,161.28 L356.05,161.28 L355.14,160.55 L353.14,162.16 L351.72,163.31 L351.72,163.31 L351.72,180.84 L358.55,180.84 L358.55,163.34 L358.56,163.34 Z M357.38,179.69 L352.91,179.69 L352.91,163.91 L355.15,162.11 L356.06,162.84 L356.63,163.3 L357.24,163.79 L357.38,163.9 L357.38,163.9 L357.38,179.69 Z"
              id="Shape"
              fill="#566373"></path>
            <polygon
              id="Shape"
              fill="#C3C9CF"
              points="74.53 161.32 75.67 162.24 76.88 163.22 74.53 161.32"></polygon>
            <rect
              id="Rectangle-path"
              fill="#4B5766"
              x="70.21"
              y="178.36"
              width="0.0"
              height="2.51"></rect>
            <polygon
              id="Shape"
              fill="#4B5766"
              points="74.53 161.32 75.62 162.2 75.67 162.24 74.53 161.32"></polygon>
            <polygon
              id="Shape"
              fill="#E1E5E9"
              points="75.86 179.33 75.86 178.7 75.86 163.91 75.81 163.87 74.53 162.84 73.62 162.1 72.29 163.18 71.39 163.91 71.39 176.31 71.39 177.07 71.39 177.75 71.39 178.36 71.39 179.69 71.39 179.69 75.17 179.69 75.86 179.69"></polygon>
            <path
              d="M77,179.07 L77,163.34 L77,163.34 L76.84,163.21 L75.63,162.21 L75.58,162.21 L74.5,161.34 L74.5,161.34 L73.59,160.61 L71.91,162 L70.2,163.38 L70.2,163.38 L70.2,178.38 L70.2,178.38 L70.2,180.89 L77,180.89 L77,179.09 L77,179.07 Z M71.35,179.69 L71.35,179.69 L71.35,163.91 L72.25,163.18 L73.59,162.1 L74.5,162.83 L75.78,163.83 L75.83,163.83 L75.83,179.61 L71.39,179.61 L71.35,179.69 Z"
              id="Shape"
              fill="#566373"></path>
            <polygon
              id="Shape"
              fill="#C3C9CF"
              points="84.1 161.32 85.05 162.09 86.48 163.24 84.1 161.32"></polygon>
            <polygon
              id="Shape"
              fill="#4B5766"
              points="84.1 161.32 84.9 161.97 85.05 162.09 84.1 161.32"></polygon>
            <polygon
              id="Shape"
              fill="#4B5766"
              points="79.77 180.12 79.77 179.53 79.77 178.36 79.77 178.36 79.77 179.53 79.77 180.12 79.77 180.71 79.77 180.87 79.77 180.87 79.77 180.71"></polygon>
            <polygon
              id="Shape"
              fill="#E1E5E9"
              points="82.67 179.69 83.85 179.69 85.43 179.69 85.43 179.57 85.43 165.05 85.43 163.91 85.39 163.88 85.3 163.81 84.1 162.84 83.85 162.64 83.19 162.1 82.67 162.52 81.85 163.18 80.95 163.91 80.95 178.36 80.95 179.58 80.95 179.69 80.95 179.69"></polygon>
            <path
              d="M86.61,179.52 L86.61,163.34 L86.49,163.24 L86.49,163.24 L85,162.09 L84.9,162 L84.1,161.36 L84.1,161.36 L83.85,161.16 L83.19,160.63 L82.67,161.05 L80.61,162.71 L79.77,163.39 L79.77,163.39 L79.77,178.39 L79.77,178.39 L79.77,180.9 L86.6,180.9 L86.6,179.55 L86.61,179.52 Z M80.96,179.59 L80.96,163.91 L81.86,163.18 L82.68,162.52 L83.2,162.1 L83.86,162.63 L84.11,162.83 L85.31,163.83 L85.4,163.9 L85.4,163.9 L85.4,179.68 L81,179.68 L80.96,179.59 Z"
              id="Shape"
              fill="#566373"></path>
            <polygon
              id="Shape"
              fill="#C3C9CF"
              points="93.67 161.32 94.43 161.94 94.47 161.97 95.9 163.13 93.67 161.32"></polygon>
            <polygon
              id="Shape"
              fill="#4B5766"
              points="93.67 161.32 94.43 161.94 93.67 161.32"></polygon>
            <polygon
              id="Shape"
              fill="#4B5766"
              points="89.34 179.59 89.34 178.97 89.34 178.36 89.34 178.36 89.34 178.97 89.34 179.59 89.34 180.2 89.34 180.87 89.34 180.87 89.34 180.2"></polygon>
            <polygon
              id="Shape"
              fill="#E1E5E9"
              points="92.76 162.1 91.42 163.18 90.52 163.91 90.52 178.36 90.52 178.59 90.52 179.22 90.52 179.69 90.52 179.69 90.92 179.69 95 179.69 95 177.56 95 176.86 95 176.1 95 163.91 93.67 162.84"></polygon>
            <path
              d="M96.17,175.14 L96.17,163.34 L95.9,163.12 L94.47,162 L94.47,162 L93.71,161.39 L93.71,161.39 L93.55,161.26 L92.8,160.65 L90.22,162.73 L89.86,163.02 L89.38,163.4 L89.38,163.4 L89.38,178.4 L89.38,178.4 L89.38,180.91 L96.21,180.91 L96.21,175.18 L96.17,175.14 Z M94.99,176.14 L94.99,179.73 L90.52,179.73 L90.52,163.91 L91.42,163.18 L92.76,162.1 L93.67,162.83 L95,163.91 L94.99,176.14 Z"
              id="Shape"
              fill="#566373"></path>
            <polygon
              id="Shape"
              fill="#DDE0E3"
              points="105.48 163.13 104.47 162.31 104.47 162.31"></polygon>
            <polygon
              id="Shape"
              fill="#C3C9CF"
              points="103.41 161.47 103.4 161.45 103.23 161.32 103.23 161.32 103.4 161.46 103.41 161.47"></polygon>
            <polygon
              id="Shape"
              fill="#ABB0BA"
              points="103.41 161.47 103.41 161.47 103.52 161.55 103.75 161.74 103.92 161.88 104.45 162.3 104.47 162.31 104.47 162.31 104.45 162.3 103.92 161.88"></polygon>
            <polygon
              id="Shape"
              fill="#4B5766"
              points="103.4 161.46 103.52 161.55 103.41 161.47"></polygon>
            <polygon
              id="Shape"
              fill="#E1E5E9"
              points="103.23 162.84 103.17 162.79 102.32 162.1 100.73 163.39 100.09 163.91 100.09 170.49 100.09 171.6 100.09 172.58 100.09 178.36 100.09 179.69 100.09 179.69 104.56 179.69 104.56 163.91 104.19 163.6 103.68 163.2"></polygon>
            <path
              d="M104.47,162.32 L104.47,162.32 L103.94,161.9 L103.76,161.76 L103.53,161.58 L103.41,161.48 L103.25,161.35 L102.34,160.62 L101.12,161.62 L98.92,163.39 L98.92,180.92 L105.75,180.92 L105.75,163.34 L105.49,163.13 L104.47,162.32 Z M104.57,163.91 L104.57,179.69 L100.09,179.69 L100.09,163.91 L100.73,163.39 L102.33,162.1 L103.18,162.78 L103.24,162.83 L103.69,163.19 L104.2,163.6 L104.57,163.91 Z"
              id="Shape"
              fill="#566373"></path>
            <polygon
              id="Shape"
              fill="#DDE0E3"
              points="113.29 161.97 114.86 163.23 112.49 161.32 112.49 161.32 112.49 161.32"></polygon>
            <rect
              id="Rectangle-path"
              fill="#4B5766"
              x="115"
              y="163.34"
              width="0.0"
              height="17.53"></rect>
            <polygon
              id="Shape"
              fill="#E1E5E9"
              points="113.82 179.69 113.82 163.91 112.53 162.87 112.49 162.84 111.58 162.1 109.34 163.91 109.34 178.36 109.34 179.54 109.34 179.69 113.82 179.69"></polygon>
            <path
              d="M115,163.34 L114.86,163.23 L113.29,162 L112.49,161.36 L112.49,161.36 L111.58,160.63 L109.58,162.24 L108.16,163.39 L108.16,163.39 L108.16,180.92 L115,180.92 L115,163.34 Z M109.35,179.54 L109.35,163.91 L111.59,162.11 L112.5,162.84 L112.5,162.84 L113.79,163.84 L113.79,179.62 L109.31,179.62 L109.35,179.54 Z"
              id="Shape"
              fill="#566373"></path>
            <polygon
              id="Shape"
              fill="#DDE0E3"
              points="47.2 162.39 48.2 163.19 45.88 161.32 45.88 161.32 46.96 162.2"></polygon>
            <polygon
              id="Shape"
              fill="#4B5766"
              points="46.96 162.2 45.88 161.32 45.88 161.32"></polygon>
            <rect
              id="Rectangle-path"
              fill="#4B5766"
              x="41.55"
              y="178.36"
              width="0.0"
              height="2.51"></rect>
            <polygon
              id="Shape"
              fill="#E1E5E9"
              points="47.21 179.69 47.21 163.91 47.16 163.87 45.88 162.84 44.97 162.1 43.63 163.18 42.73 163.91 42.73 178.36 42.73 179.69 42.73 179.69"></polygon>
            <path
              d="M47.2,162.39 L47,162.2 L45.92,161.33 L45.92,161.33 L45.01,160.6 L43.26,162 L41.55,163.38 L41.55,163.38 L41.55,178.38 L41.55,178.38 L41.55,180.89 L48.38,180.89 L48.38,163.34 L48.38,163.34 L48.19,163.19 L47.2,162.39 Z M42.73,178.39 L42.73,163.91 L43.63,163.18 L45,162.1 L45.91,162.83 L47.19,163.83 L47.19,163.83 L47.19,179.61 L42.73,179.61 L42.73,178.39 Z"
              id="Shape"
              fill="#566373"></path>
            <polygon
              id="Shape"
              fill="#DDE0E3"
              points="56.24 161.97 56.63 162.28 57.7 163.14 55.45 161.32 55.45 161.32 56.18 161.91"></polygon>
            <rect
              id="Rectangle-path"
              fill="#4B5766"
              x="51.12"
              y="178.36"
              width="0.0"
              height="2.51"></rect>
            <polygon
              id="Shape"
              fill="#4B5766"
              points="56.24 161.97 56.18 161.91 55.45 161.32 55.45 161.32 55.45 161.32"></polygon>
            <polygon
              id="Shape"
              fill="#E1E5E9"
              points="56.77 179.69 56.77 163.91 56.74 163.88 55.45 162.84 54.54 162.1 53.2 163.18 52.3 163.91 52.3 178.36 52.3 179.69 52.3 179.69"></polygon>
            <path
              d="M56.63,162.28 L56.25,161.97 L55.45,161.33 L55.45,161.33 L54.54,160.6 L52,162.67 L51.16,163.35 L51.16,163.35 L51.16,178.35 L51.16,178.35 L51.16,180.86 L58,180.86 L58,163.34 L57.75,163.14 L56.63,162.28 Z M52.3,178.36 L52.3,163.91 L53.2,163.18 L54.54,162.1 L55.45,162.83 L56.74,163.83 L56.74,163.83 L56.74,179.61 L52.3,179.61 L52.3,178.36 Z"
              id="Shape"
              fill="#566373"></path>
            <polygon
              id="Shape"
              fill="#C3C9CF"
              points="64.7 161.32 65.24 161.76 65.5 161.97 67.09 163.24 64.7 161.32"></polygon>
            <polygon
              id="Shape"
              fill="#4B5766"
              points="67.21 172.24 67.21 172.23 67.21 163.34 67.21 163.34 67.21 172.23 67.21 173.19 67.21 174.07 67.21 180.87 67.21 180.87 67.21 174.07 67.21 173.19"></polygon>
            <polygon
              id="Shape"
              fill="#E1E5E9"
              points="65.36 163.37 65.13 163.18 64.7 162.84 63.79 162.1 62.93 162.8 62.42 163.21 61.91 163.62 61.55 163.91 61.55 178.36 61.55 179.54 61.55 179.69 66.03 179.69 66.03 179.69 66.03 172.6 66.03 171.62 66.03 170.53 66.03 163.91"></polygon>
            <path
              d="M67.21,173.19 L67.21,163.34 L67.21,163.34 L67.09,163.24 L65.5,162 L65.24,161.79 L64.7,161.36 L63.79,160.63 L62.7,161.51 L62.17,161.93 L61.79,162.23 L61.64,162.35 L60.37,163.35 L60.37,163.35 L60.37,180.88 L67.2,180.88 L67.2,173.2 L67.21,173.19 Z M66,171.62 L66,179.69 L61.55,179.69 L61.55,163.91 L61.91,163.62 L62.41,163.21 L62.92,162.8 L63.78,162.1 L64.69,162.83 L65.12,163.17 L65.35,163.36 L66.02,163.9 L66.02,171.62 L66,171.62 Z"
              id="Shape"
              fill="#566373"></path>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="193.78 82.27 193.78 82.86 193.78 92.26 194.36 92.26 194.95 92.26 194.95 82.86 194.95 82.27 194.95 81.68 194.95 74.99 193.78 74.99 193.78 81.68"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="200.43 82.27 200.43 82.86 200.43 92.26 201.02 92.26 201.61 92.26 201.61 82.86 201.61 82.27 201.61 81.68 201.61 74.99 200.43 74.99 200.43 81.68"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="187.71 92.26 188.3 92.26 188.3 82.86 188.3 82.27 188.3 81.68 188.3 75 187.12 75 187.12 81.68 187.12 82.27 187.12 82.86 187.12 92.26"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="207.09 82.27 207.09 82.86 207.09 92.26 207.68 92.26 208.27 92.26 208.27 82.86 208.27 82.27 208.27 81.68 208.27 74.99 207.09 74.99 207.09 81.68"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="213.74 82.27 213.74 82.86 213.74 92.26 214.33 92.26 214.92 92.26 214.92 82.86 214.92 82.27 214.92 81.68 214.92 74.99 213.74 74.99 213.74 81.68"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="220.4 82.27 220.4 82.86 220.4 92.26 220.99 92.26 221.58 92.26 221.58 82.86 221.58 82.27 221.58 81.68 221.58 74.99 220.4 74.99 220.4 81.68"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="227.06 82.27 227.06 82.86 227.06 92.26 227.65 92.26 228.24 92.26 228.24 82.86 228.24 82.27 228.24 81.68 228.24 74.99 227.06 74.99 227.06 81.68"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="233.71 82.27 233.71 82.86 233.71 92.26 234.3 92.26 234.89 92.26 234.89 82.86 234.89 82.27 234.89 81.68 234.89 74.99 233.71 74.99 233.71 81.68"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="240.37 82.27 240.37 82.86 240.37 92.26 240.96 92.26 241.55 92.26 241.55 82.86 241.55 82.27 241.55 81.68 241.55 74.99 240.37 74.99 240.37 81.68"></polygon>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="172.38"
              y="82.86"
              width="1.18"
              height="41.28"></rect>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="165.72"
              y="82.86"
              width="1.18"
              height="41.28"></rect>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="185.89 121.99 186.87 121.47 186.87 114.8 185.69 114.8 185.69 122.1"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="180.21 124.14 180.21 93.57 179.21 93.57 179.07 93.57 179.07 124.15"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="192.43 118.52 193.53 117.93 193.53 114.8 192.35 114.8 192.35 118.56"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="193.53 119.27 193.46 119.31 193.53 119.31"></polygon>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="159.07"
              y="82.86"
              width="1.18"
              height="41.28"></rect>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="152.41"
              y="82.86"
              width="1.18"
              height="41.28"></rect>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="145.75"
              y="82.86"
              width="1.18"
              height="41.28"></rect>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="139.1"
              y="82.86"
              width="1.18"
              height="41.28"></rect>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="132.44"
              y="82.86"
              width="1.18"
              height="41.28"></rect>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="125.78"
              y="82.86"
              width="1.18"
              height="41.28"></rect>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="255.41"
              y="82.86"
              width="1.18"
              height="41.28"></rect>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="262.07"
              y="82.86"
              width="1.18"
              height="41.28"></rect>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="243.28 114.8 242.1 114.8 242.1 122.34 242.82 122.72 243.28 122.72"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="249.35 82.69 248.76 82.69 248.76 124.14 249.94 124.14 249.94 82.69"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="236.62 114.8 235.44 114.8 235.44 118.8 235.61 118.89 236.39 119.31 236.39 119.31 236.62 119.31"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="268.73 90.32 268.73 90.91 268.73 124.14 269.91 124.14 269.91 90.91 269.91 90.32 269.91 89.73 269.91 85.63 269.91 82.86 269.64 82.86 269.24 82.86 268.73 82.86 268.73 85.63"></polygon>
            <polygon
              id="Shape"
              fill="#DBDEE1"
              points="275.38 89.73 275.38 90.32 275.38 90.91 275.38 124.14 276.56 124.14 276.56 90.91 276.56 90.32 276.56 85.63 276.56 82.86 276.02 82.86 275.38 82.86 275.38 85.63"></polygon>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="282.04"
              y="82.86"
              width="1.18"
              height="41.28"></rect>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="288.7"
              y="82.86"
              width="1.18"
              height="41.28"></rect>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="295.35"
              y="82.86"
              width="1.18"
              height="41.28"></rect>
            <rect
              id="Rectangle-path"
              fill="#DBDEE1"
              x="302.01"
              y="82.86"
              width="1.18"
              height="41.28"></rect>
            <polygon
              id="Shape"
              fill="#FFFFFF"
              points="37.67 66.13 38.37 72.61 43.46 68.54 41.99 63.9"></polygon>
            <path
              d="M44.71,68.57 L42.91,62.88 C42.8581807,62.7143732 42.7360701,62.5799605 42.5761623,62.5125295 C42.4162544,62.4450985 42.2347691,62.4514888 42.08,62.53 L36.77,65.27 C36.5509614,65.3809261 36.4235137,65.6159079 36.45,65.86 L37.3,73.64 C36.9478911,74.4353916 36.3288688,75.0827121 35.55,75.47 C33.4196077,76.5905335 32.3900054,79.0699839 33.1,81.37 C33.15,81.59 33.2,81.79 33.24,82.01 C33.3630507,82.6823415 33.2793703,83.3761917 33,84 C32.6689783,84.8701539 32.0229033,85.584049 31.19,86 L30.89,86.19 C29.9799385,86.7146459 29.2748317,87.5325697 28.89,88.51 C28.7659637,88.8109949 28.9091657,89.1555747 29.21,89.28 L29.44,89.28 C29.6757604,89.2786705 29.8880957,89.1371136 29.98,88.92 C30.3110217,88.0498461 30.9570967,87.335951 31.79,86.92 C33.9203923,85.7994665 34.9499946,83.3200161 34.24,81.02 C34.19,80.8 34.14,80.6 34.1,80.38 C33.9779947,79.7034227 34.0652066,79.0057275 34.35,78.38 C34.6801692,77.5093243 35.3264927,76.7951547 36.16,76.38 L36.46,76.19 C37.3156783,75.6907093 37.9886431,74.9301189 38.38,74.02 L44.52,69.11 C44.6722633,68.9748398 44.7440812,68.7707258 44.71,68.57 Z M38.38,72.57 L37.68,66.09 L42,63.9 L43.47,68.54 L38.38,72.57 Z"
              id="Shape"
              fill="#C5C9D1"></path>
            <path
              d="M34.35,78.43 C34.0652066,79.0557275 33.9779947,79.7534227 34.1,80.43 L36.46,76.26 L36.16,76.45 C35.3302237,76.8603423 34.6844049,77.5668182 34.35,78.43 L34.35,78.43 Z"
              id="Shape"
              fill="#FFFFFF"></path>
            <path
              d="M33,84 C33.2847934,83.3742725 33.3720053,82.6765773 33.25,82 L30.89,86.17 L31.19,85.98 C32.0191828,85.5688689 32.6647564,84.8626613 33,84 L33,84 Z"
              id="Shape"
              fill="#FFFFFF"></path>
            <path
              d="M120.87,57.3 C129.568485,57.3 136.62,50.2484848 136.62,41.55 C136.62,32.8515152 129.568485,25.8 120.87,25.8 C112.171515,25.8 105.12,32.8515152 105.12,41.55 C105.125516,50.2461989 112.173801,57.2944839 120.87,57.3 L120.87,57.3 Z"
              id="Shape"
              fill="#FFFFFF"></path>
            <path
              d="M120.87,58.48 C130.220181,58.48 137.8,50.9001808 137.8,41.55 C137.8,32.1998192 130.220181,24.62 120.87,24.62 C111.519819,24.62 103.94,32.1998192 103.94,41.55 C103.945517,50.8978948 111.522105,58.4744834 120.87,58.48 Z M120.87,25.81 C129.568485,25.81 136.62,32.8615152 136.62,41.56 C136.62,50.2584848 129.568485,57.31 120.87,57.31 C112.171515,57.31 105.12,50.2584848 105.12,41.56 C105.125516,32.8638011 112.173801,25.8155161 120.87,25.81 L120.87,25.81 Z"
              id="Shape"
              fill="#C5C9D1"></path>
            <polygon
              id="Shape"
              fill="#C5C9D1"
              points="100.51 41.91 100.51 41.32 96.99 41.32 96.99 42.5 100.51 42.5"></polygon>
            <polygon
              id="Shape"
              fill="#C5C9D1"
              points="141.22 42.41 144.74 42.41 144.74 41.82 144.74 41.23 141.22 41.23"></polygon>
            <polygon
              id="Shape"
              fill="#C5C9D1"
              points="121.41 21.51 121.41 17.99 120.82 17.99 120.23 17.99 120.23 21.51 120.82 21.51"></polygon>
            <rect
              id="Rectangle-path"
              fill="#C5C9D1"
              x="120.32"
              y="62.22"
              width="1.18"
              height="3.52"></rect>
            <polygon
              id="Shape"
              fill="#C5C9D1"
              points="106.09 55.88 103.6 58.36 104.02 58.78 104.44 59.2 106.92 56.71 106.5 56.29"></polygon>
            <polygon
              id="Shape"
              fill="#C5C9D1"
              points="135.65 27.86 138.13 25.37 137.72 24.95 137.3 24.53 134.81 27.02 135.23 27.44"></polygon>
            <polygon
              id="Shape"
              fill="#C5C9D1"
              points="106.86 27.09 104.37 24.6 103.95 25.02 103.53 25.43 106.02 27.92"></polygon>
            <rect
              id="Rectangle-path"
              fill="#C5C9D1"
              transform="translate(136.543970, 57.483505) rotate(-44.990000) translate(-136.543970, -57.483505) "
              x="135.95397"
              y="55.7235048"
              width="1.18"
              height="3.52"></rect>
            <polygon
              id="Shape"
              fill="#C5C9D1"
              points="101.81 49.03 98.55 50.36 98.77 50.91 98.99 51.45 102.25 50.13 102.03 49.58"></polygon>
            <polygon
              id="Shape"
              fill="#C5C9D1"
              points="143.19 33.37 142.97 32.83 142.74 32.28 139.48 33.61 139.93 34.7"></polygon>
            <polygon
              id="Shape"
              fill="#C5C9D1"
              points="113.7 22.8 112.37 19.55 111.83 19.77 111.28 19.99 112.61 23.25"></polygon>
            <polygon
              id="Shape"
              fill="#C5C9D1"
              points="128.03 60.93 129.36 64.19 130.45 63.74 129.13 60.48 128.58 60.7"></polygon>
            <polygon
              id="Shape"
              fill="#C5C9D1"
              points="111.09 63.65 111.63 63.88 112.18 64.11 113.54 60.87 113 60.64 112.46 60.41"></polygon>
            <polygon
              id="Shape"
              fill="#C5C9D1"
              points="129.28 23.32 130.64 20.08 130.1 19.85 129.56 19.62 128.19 22.86 128.73 23.09"></polygon>
            <polygon
              id="Shape"
              fill="#C5C9D1"
              points="102.09 34 102.32 33.45 99.08 32.09 98.85 32.63 98.62 33.17 101.86 34.54"></polygon>
            <polygon
              id="Shape"
              fill="#C5C9D1"
              points="143.11 50.56 139.87 49.19 139.64 49.73 139.41 50.27 142.66 51.64"></polygon>
            <path
              d="M306,130.72 L308.67,130.72 C308.995848,130.72 309.26,130.455848 309.26,130.13 L309.26,124.82 L309.26,124.82 L309.26,124.82 L309.26,82.27 C309.26,81.944152 308.995848,81.68 308.67,81.68 L277.2,81.68 L277.2,69.68 L279.26,69.68 L279.26,68.51 L266,68.51 L266,69.69 L268.06,69.69 L268.06,81.69 L248.75,81.69 L248.75,74.4 C248.75,74.074152 248.485848,73.81 248.16,73.81 L179.16,73.81 C178.834152,73.81 178.57,74.074152 178.57,74.4 L178.57,81.68 L120.31,81.68 C119.984152,81.68 119.72,81.944152 119.72,82.27 L119.72,124.73 L119.72,124.73 L119.72,124.73 L119.72,130.04 C119.72,130.365848 119.984152,130.63 120.31,130.63 L121.31,130.63 L118.92,164 L116.81,164 L116.81,165.18 L118.87,165.18 L118.87,183.18 C118.87,183.505848 119.134152,183.77 119.46,183.77 L130.07,183.77 C130.395848,183.77 130.66,183.505848 130.66,183.18 L130.66,181.12 L181.23,181.12 L181.23,183.18 C181.23,183.505848 181.494152,183.77 181.82,183.77 L245.5,183.77 C245.825848,183.77 246.09,183.505848 246.09,183.18 L246.09,181.12 L296.65,181.12 L296.65,183.18 C296.65,183.505848 296.914152,183.77 297.24,183.77 L307.85,183.77 C308.175848,183.77 308.44,183.505848 308.44,183.18 L308.44,165.18 L310.5,165.18 L310.5,164 L308.4,164 L306,130.72 Z M307.24,166.83 L307.24,182.61 L297.81,182.61 L297.81,165.21 L307.24,165.21 L307.24,166.83 Z M244.88,182.61 L235.45,182.61 L235.45,165.21 L244.88,165.21 L244.88,182.61 Z M192.99,182.61 L192.99,178.48 L234.27,178.48 L234.27,182.61 L192.99,182.61 Z M186.61,182.61 L182.38,182.61 L182.38,165.21 L191.82,165.21 L191.82,182.61 L186.61,182.61 Z M129.46,181.14 L129.46,182.61 L120.02,182.61 L120.02,165.21 L129.46,165.21 L129.46,181.13 L129.46,181.14 Z M120.86,82.86 L178.55,82.86 L178.55,93 C178.552428,93.2682775 178.738535,93.4998774 179,93.56 L179,93.56 L179.14,93.56 L248.14,93.56 C248.465848,93.56 248.73,93.295848 248.73,92.97 L248.73,82.86 L308.09,82.86 L308.09,124.14 L245.47,124.14 L242.82,122.73 L242.1,122.35 L236.39,119.35 L236.39,119.35 L235.61,118.94 L235.44,118.85 L227.9,114.85 L245.5,114.85 C245.825848,114.85 246.09,114.585848 246.09,114.26 L246.09,95.72 L244.91,95.72 L244.91,113.61 L225.68,113.61 L213.94,107.37 C213.767879,107.279322 213.562121,107.279322 213.39,107.37 L201.65,113.61 L182.41,113.61 L182.41,95.72 L181.23,95.72 L181.23,114.2 C181.23,114.525848 181.494152,114.79 181.82,114.79 L199.42,114.79 L193.52,117.93 L193.52,117.93 L192.42,118.51 L192.34,118.51 L186.86,121.42 L185.86,121.94 L185.66,122.04 L181.83,124.04 L120.83,124.04 L120.86,82.86 Z M179.73,81.68 L179.73,75 L247.54,75 L247.54,92.39 L179.76,92.39 L179.76,81.68 L179.73,81.68 Z M269.24,80 L269.24,69.68 L276,69.68 L276,81.68 L269.22,81.68 L269.24,80 Z M296.66,171.81 L296.66,172 L246.1,172 L246.1,165.22 L248.16,165.22 L248.16,164 L246.06,164 L243.93,134.24 L243.81,132.56 L243.73,131.4 L247.48,131.4 L247.58,131.4 L247.68,131.4 L247.76,131.4 L247.76,131.4 L247.76,131.4 L247.76,131.4 C247.802863,131.362315 247.839929,131.318509 247.87,131.27 L247.87,131.27 L247.87,131.27 L247.87,131.27 L247.87,131.22 C247.874149,131.180108 247.874149,131.139892 247.87,131.1 L247.87,131.1 L247.87,131.1 L247.87,130.98 L298.87,130.98 L298.62,134.53 L296.7,164 L294.6,164 L294.6,165.18 L296.66,165.18 L296.66,171.81 Z M234.3,171.81 L234.3,172 L223.87,172 L223.87,135.43 C223.87,135.104152 223.605848,134.84 223.28,134.84 L204.05,134.84 C203.724152,134.84 203.46,135.104152 203.46,135.43 L203.46,172 L193,172 L193,165.22 L195.06,165.22 L195.06,164 L193,164 L190.67,131.4 L236.67,131.4 L236.47,134.24 L234.35,164 L232.25,164 L232.25,165.18 L234.31,165.18 L234.3,171.81 Z M234.3,174.4 L234.3,177.34 L193,177.34 L193,173.21 L234.28,173.21 L234.28,174.4 L234.3,174.4 Z M204.64,171.81 L204.64,136 L222.64,136 L222.64,172 L204.64,172 L204.64,171.81 Z M181.23,171.81 L181.23,172 L130.67,172 L130.67,165.22 L132.73,165.22 L132.73,164 L130.62,164 L128.49,134.24 L128.24,130.69 L179.24,130.69 L179.24,130.81 L179.24,130.81 C179.234347,130.856495 179.234347,130.903505 179.24,130.95 C179.23707,130.983269 179.23707,131.016731 179.24,131.05 L179.24,131.05 L179.29,131.12 L179.29,131.12 L179.37,131.19 L179.37,131.19 L179.37,131.19 L179.37,131.19 L179.53,131.19 L183.32,131.19 L183.12,134.03 L181.28,164 L179.18,164 L179.18,165.18 L181.24,165.18 L181.23,171.81 Z M180.44,128.17 L180.44,126.26 L181.97,125.44 L182.15,125.35 L183.08,124.85 L183.26,124.76 L184.19,124.26 L184.37,124.17 L193.45,119.34 L193.52,119.34 L201.93,114.87 L203.04,114.28 L204.15,113.69 L213.66,108.64 L223.17,113.69 L224.28,114.28 L225.39,114.87 L243,124.14 L243.18,124.23 L244.11,124.73 L244.29,124.82 L245.22,125.32 L245.4,125.41 L246.93,126.23 L246.93,129.86 L246.33,129.54 L243.7,128.14 L243.53,128.05 L242.92,127.72 L242.59,127.55 L242.45,127.48 L241.45,126.96 L241.31,126.89 L240.15,126.27 L238.54,125.41 L238.36,125.32 L237.43,124.82 L237.25,124.73 L236.32,124.23 L236.14,124.14 L232.51,122.21 L218.57,114.8 L217.46,114.21 L216.35,113.62 L213.95,112.35 C213.777879,112.259322 213.572121,112.259322 213.4,112.35 L211,113.62 L209.89,114.21 L208.78,114.8 L194.84,122.21 L191.21,124.14 L191.03,124.23 L190.1,124.73 L189.92,124.82 L188.99,125.32 L188.81,125.41 L187.2,126.26 L186.03,126.88 L185.89,126.95 L184.89,127.47 L184.75,127.54 L184.42,127.71 L183.81,128.04 L183.64,128.13 L181.01,129.53 L180.41,129.85 L180.41,128.13 L180.44,128.17 Z M212.44,114.24 L213.55,113.65 L213.71,113.56 L213.87,113.65 L214.98,114.24 L216.09,114.83 L233.66,124.17 L233.84,124.26 L234.77,124.76 L234.95,124.85 L235.88,125.35 L236.06,125.44 L238.83,126.91 L238.97,126.98 L239.97,127.5 L240.11,127.57 L241.11,128.09 L241.25,128.16 L242.46,128.81 L243.07,129.14 L243.68,129.47 L243.87,129.57 L244.98,130.16 L245.12,130.23 L245.21,130.23 L182.31,130.23 L182.4,130.23 L182.54,130.16 L183.65,129.57 L183.84,129.47 L184.45,129.14 L185.06,128.81 L186.27,128.16 L186.41,128.09 L187.41,127.57 L187.55,127.5 L188.55,126.98 L188.69,126.91 L191.46,125.44 L191.64,125.35 L192.57,124.85 L192.75,124.76 L193.68,124.26 L193.86,124.17 L211.43,114.83 L212.44,114.24 Z M184.83,131.46 L189.52,131.46 L191.85,164.06 L182.5,164.06 L184.83,131.46 Z M237.9,131.46 L242.59,131.46 L244.92,164.06 L235.57,164.06 L237.9,131.46 Z M303.36,164 L297.88,164 L300.26,130.68 L304.85,130.68 L307.23,164 L303.36,164 Z M305.36,129.5 L248.07,129.5 L248.07,125.83 C248.064548,125.645638 247.971734,125.474861 247.82,125.37 L308.12,125.37 L308.12,129.5 L305.36,129.5 Z M120.89,125.37 L179.51,125.37 C179.358266,125.474861 179.265452,125.645638 179.26,125.83 L179.26,129.5 L120.89,129.5 L120.89,125.37 Z M124.98,130.68 L127.06,130.68 L129.45,164 L120.1,164 L122.48,130.68 L124.98,130.68 Z M130.67,175 L130.67,173.22 L181.24,173.22 L181.24,180 L130.67,180 L130.67,175 Z M246.1,175 L246.1,173.22 L296.66,173.22 L296.66,180 L246.1,180 L246.1,175 Z"
              id="Shape"
              fill="#4C5A68"></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default ConfirmSellerArtwork;
